var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2159 1368.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#91b3fa;}.cls-3{fill:#7d97f4;}.cls-4{fill:#bdd0fb;}.cls-5{fill:#dce5fe;}.cls-6,.cls-77{fill:#2b69b3;}.cls-12,.cls-18,.cls-56,.cls-7,.cls-70,.cls-75,.cls-79{fill:#fff;}.cls-8{fill:#18174a;}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11,.cls-12{opacity:0.6;}.cls-13{fill:url(#linear-gradient-4);}.cls-14{fill:url(#linear-gradient-5);}.cls-15{fill:url(#linear-gradient-6);}.cls-16{fill:url(#linear-gradient-7);}.cls-17{fill:url(#linear-gradient-8);}.cls-18{opacity:0.5;}.cls-19{fill:url(#linear-gradient-9);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-11);}.cls-22{fill:url(#linear-gradient-12);}.cls-23{fill:url(#linear-gradient-13);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:url(#linear-gradient-15);}.cls-26{fill:url(#linear-gradient-16);}.cls-27{fill:url(#linear-gradient-17);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#linear-gradient-20);}.cls-31{fill:url(#linear-gradient-21);}.cls-32{fill:url(#linear-gradient-22);}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#linear-gradient-24);}.cls-35{fill:url(#linear-gradient-25);}.cls-36{fill:url(#linear-gradient-26);}.cls-37{fill:url(#linear-gradient-27);}.cls-38{fill:url(#linear-gradient-28);}.cls-39{fill:url(#linear-gradient-29);}.cls-40{fill:url(#linear-gradient-30);}.cls-41{fill:url(#linear-gradient-31);}.cls-42{fill:url(#linear-gradient-32);}.cls-43{fill:url(#linear-gradient-33);}.cls-44{fill:url(#linear-gradient-34);}.cls-45{fill:url(#linear-gradient-35);}.cls-46{fill:url(#linear-gradient-36);}.cls-47{fill:url(#linear-gradient-37);}.cls-48{fill:url(#linear-gradient-38);}.cls-49{fill:url(#linear-gradient-39);}.cls-50{fill:url(#linear-gradient-40);}.cls-51{fill:url(#linear-gradient-41);}.cls-52{fill:url(#linear-gradient-42);}.cls-53{fill:url(#linear-gradient-43);}.cls-54{fill:url(#linear-gradient-44);}.cls-55{fill:url(#linear-gradient-45);}.cls-56{opacity:0.9;}.cls-57{fill:url(#linear-gradient-46);}.cls-58{fill:url(#linear-gradient-47);}.cls-59{fill:url(#linear-gradient-48);}.cls-60{fill:url(#linear-gradient-49);}.cls-61{fill:url(#linear-gradient-50);}.cls-62{fill:url(#linear-gradient-51);}.cls-63{fill:url(#linear-gradient-52);}.cls-64,.cls-65,.cls-66,.cls-67,.cls-70{opacity:0.56;}.cls-64{fill:url(#linear-gradient-53);}.cls-65{fill:url(#linear-gradient-54);}.cls-66{fill:url(#linear-gradient-55);}.cls-67{fill:url(#linear-gradient-56);}.cls-68{opacity:0.64;}.cls-69{fill:url(#linear-gradient-57);}.cls-71{fill:url(#linear-gradient-58);}.cls-72{fill:url(#linear-gradient-59);}.cls-73{fill:url(#linear-gradient-60);}.cls-74{fill:url(#linear-gradient-61);}.cls-75{opacity:0.2;}.cls-76{fill:url(#linear-gradient-62);}.cls-77,.cls-79{opacity:0.63;}.cls-78{fill:url(#linear-gradient-63);}.cls-80{fill:url(#linear-gradient-64);}.cls-81{fill:url(#linear-gradient-65);}.cls-82{fill:url(#linear-gradient-66);}.cls-83{fill:url(#linear-gradient-67);}.cls-84{fill:url(#linear-gradient-68);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1764.65,
    y1: 745.02,
    x2: 394.35,
    y2: 745.02,
    gradientTransform: "translate(394.35 1379.13) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1834.28,
    y1: 715.95,
    x2: 1886.48,
    y2: 715.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1837.05,
    y1: 661.81,
    x2: 1839.39,
    y2: 661.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1679.83,
    y1: 5749.91,
    x2: 1535.46,
    y2: 5996.31,
    gradientTransform: "matrix(1, 0.01, -0.01, 1, 368.94, -5383.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1706.27,
    y1: 5765.39,
    x2: 1561.89,
    y2: 6011.8,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1725.85,
    y1: 5823.73,
    x2: 1535.88,
    y2: 6088.59,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1753.28,
    y1: 5793.36,
    x2: 1608.9,
    y2: 6039.77,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 3394.37,
    y1: 3150.75,
    x2: 3279.74,
    y2: 3301.55,
    gradientTransform: "matrix(0.92, 0.38, -0.38, 0.92, 137.43, -3932.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1866.58,
    y1: 441.77,
    x2: 2054.83,
    y2: 441.77,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1756.3,
    y1: 721.48,
    x2: 1621.3,
    y2: 808.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1839.53,
    y1: 674.25,
    x2: 1742.54,
    y2: 731.25,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1694.08,
    y1: 552.74,
    x2: 1723.31,
    y2: 552.74,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -3105.85,
    y1: 774.08,
    x2: -3131.42,
    y2: 817.37,
    gradientTransform: "matrix(-1, 0, 0, 1, -1387.96, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -4160.46,
    y1: -452.03,
    x2: -4186.03,
    y2: -408.75,
    gradientTransform: "matrix(-0.92, -0.39, -0.39, 0.92, -2313.37, -436.41)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1726,
    y1: 476.98,
    x2: 1746.76,
    y2: 476.98,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1833.82,
    y1: 391.53,
    x2: 1680.73,
    y2: 615.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1847.8,
    y1: 488.82,
    x2: 1668.25,
    y2: 591.68,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1865.64,
    y1: 519.96,
    x2: 1686.1,
    y2: 622.82,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1736.08,
    y1: 410.53,
    x2: 1749.08,
    y2: 487.53,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -2169.1,
    y1: 1306.12,
    x2: -2186.27,
    y2: 1339.89,
    gradientTransform: "matrix(-1, 0, 0, 1, -1443.27, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -2201.75,
    y1: 1319.56,
    x2: -2184.65,
    y2: 1319.56,
    gradientTransform: "matrix(-1, 0, 0, 1, -1443.27, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -2208.86,
    y1: 1357.12,
    x2: -2162.86,
    y2: 1357.12,
    gradientTransform: "matrix(-1, 0, 0, 1, -1443.27, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -2214.12,
    y1: 1335.35,
    x2: -2198.07,
    y2: 1335.35,
    gradientTransform: "matrix(-1, 0, 0, 1, -1443.27, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -2379.6,
    y1: 1595.26,
    x2: -2477.6,
    y2: 1821.26,
    gradientTransform: "matrix(-1, 0, 0, 1, -1443.27, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -2165.07,
    y1: 1150.21,
    x2: -2109.06,
    y2: 1150.21,
    gradientTransform: "matrix(-1, 0, 0, 1, -1443.27, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -2430.42,
    y1: 1573.22,
    x2: -2528.42,
    y2: 1799.22,
    gradientTransform: "matrix(-1, 0, 0, 1, -1443.27, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 766.74,
    y1: 1016.6,
    x2: 745.74,
    y2: 1118.1,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -2479.88,
    y1: 1551.77,
    x2: -2577.88,
    y2: 1777.77,
    gradientTransform: "matrix(-1, 0, 0, 1, -1443.27, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 812.61,
    y1: 1136.09,
    x2: 998.51,
    y2: 851.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 879.93,
    y1: 1085.65,
    x2: 783.93,
    y2: 1192.15,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -1846.68,
    y1: 1558.87,
    x2: -1834.68,
    y2: 1510.37,
    gradientTransform: "matrix(-0.92, 0.39, 0.39, 0.92, -1057.07, 1007.6)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -1861.05,
    y1: 1555.31,
    x2: -1849.05,
    y2: 1506.81,
    gradientTransform: "matrix(-0.92, 0.39, 0.39, 0.92, -1057.07, 1007.6)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 14156.92,
    y1: 1114.48,
    x2: 14133.46,
    y2: 1149.79,
    gradientTransform: "translate(-13504.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 6386.18,
    y1: 897.39,
    x2: 6279.14,
    y2: 981.44,
    gradientTransform: "translate(-6108.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 6273.07,
    y1: 730.22,
    x2: 6312.3,
    y2: 730.22,
    gradientTransform: "translate(-6108.89)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 6320.7,
    y1: 898.6,
    x2: 6315.08,
    y2: 947.65,
    gradientTransform: "translate(-6108.89)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 6405.19,
    y1: 921.6,
    x2: 6298.15,
    y2: 1005.65,
    gradientTransform: "translate(-6108.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 6366.48,
    y1: 903.85,
    x2: 6360.86,
    y2: 952.9,
    gradientTransform: "translate(-6108.89)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 6376.77,
    y1: 560.76,
    x2: 6209.41,
    y2: 928.02,
    gradientTransform: "translate(-6108.89)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 6456.52,
    y1: 526.09,
    x2: 6417.39,
    y2: 581.29,
    gradientTransform: "translate(-6108.89)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 6439.95,
    y1: 514.35,
    x2: 6400.83,
    y2: 569.55,
    gradientTransform: "translate(-6108.89)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 6333.12,
    y1: 581.26,
    x2: 6311.66,
    y2: 673.99,
    gradientTransform: "translate(-6108.89)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 2853.94,
    y1: 3325.71,
    x2: 2815.87,
    y2: 3376.08,
    gradientTransform: "translate(-4156.87 361.82) rotate(-46.73)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 2798.18,
    y1: 3365.6,
    x2: 2828.72,
    y2: 3334.27,
    gradientTransform: "translate(-4156.87 361.82) rotate(-46.73)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 176.7,
    y1: 651.67,
    x2: 182.01,
    y2: 651.67,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -1876.14,
    y1: -1070.85,
    x2: -1855.93,
    y2: -1070.85,
    gradientTransform: "matrix(-0.75, -0.66, -0.66, 0.75, -1506.91, 605.41)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -1860.87,
    y1: -1101.5,
    x2: -1873.32,
    y2: -1062.16,
    gradientTransform: "matrix(1, 0, 0, -1, 2477.14, -43.95)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -1856.41,
    y1: -1101.5,
    x2: -1868.87,
    y2: -1062.16,
    gradientTransform: "matrix(1, 0, 0, -1, 2469.3, -46.93)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -1851.96,
    y1: -1101.5,
    x2: -1864.41,
    y2: -1062.16,
    gradientTransform: "matrix(1, 0, 0, -1, 2461.52, -49.81)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -1865.8,
    y1: -1169,
    x2: -1886.45,
    y2: -1063.78,
    gradientTransform: "matrix(-0.75, -0.66, -0.66, 0.75, -1506.91, 605.41)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 904.6,
    y1: 427.29,
    x2: 2237.76,
    y2: 1551.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 874.81,
    y1: 462.62,
    x2: 2207.96,
    y2: 1586.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 936.28,
    y1: 939.5,
    x2: 1407.04,
    y2: 939.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1424.76,
    y1: 836.54,
    x2: 1460.48,
    y2: 836.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1464.23,
    y1: 780.81,
    x2: 1486.77,
    y2: 780.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 763.2,
    y1: 387.17,
    x2: 873.13,
    y2: 387.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 4711.98,
    y1: 1024.13,
    x2: 5139.4,
    y2: 1778.2,
    gradientTransform: "translate(4396.46 -2921.98) rotate(119.58)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1255.83,
    y1: 392.23,
    x2: 1263.64,
    y2: 672.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1339.5,
    y1: 656.78,
    x2: 1464.21,
    y2: 539.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1294.06,
    y1: 739.56,
    x2: 1014.22,
    y2: 1067.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 323.71,
    y1: 519.19,
    x2: 237.24,
    y2: 663.55,
    gradientTransform: "matrix(0.82, -0.58, 0.58, 0.82, 540.66, 27.98)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1626.96,
    y1: 1120.56,
    x2: 1683.01,
    y2: 1120.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1688.52,
    y1: 759.8,
    x2: 1468.28,
    y2: 1092.52,
    gradientTransform: "translate(1618.77 -1019.83) rotate(62.61)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1681.95,
    y1: 769.34,
    x2: 1564.67,
    y2: 966.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1748.05,
    y1: 871.13,
    x2: 1586.68,
    y2: 1114.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1743.23,
    y1: 878.12,
    x2: 1657.31,
    y2: 1022.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1639.23,
    y1: 872.4,
    x2: 1430.72,
    y2: 1187.4,
    gradientTransform: "translate(1126.79 -859.42) rotate(45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1633.01,
    y1: 881.43,
    x2: 1521.98,
    y2: 1067.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.53,723c70.89,29.62,159.25,31.35,231.09,65.45,78.1,37.07,46.85,106,27.77,174.88-18.31,66.1,31.32,162.9,76.56,205.24,187.49,175.47,463.38,74.46,670.3,3.22,134.75-46.4,285.82-50.94,424.39-19.82,122,27.41,239,104.41,362,37.42,114.51-62.34,190.48-205.43,178.21-339.26-7.38-80.52-38.36-162.65-60.48-240.1-22.74-79.57,19.9-125.86,65-190.8,54.14-77.87,92.08-211.5,35.65-297.56C2094.68,66.19,2025.19,34.84,1960,44.5c-57.21,8.47-99,11.79-152.36,40.24-46.75,24.92-93.13,55.92-147.41,59.67-53.64,3.71-104.86-20.54-153.25-44.2C1421.53,58.44,1346.26,17.78,1251,6.6A661.35,661.35,0,0,0,978.89,31.5C924.34,48.43,872.23,72.36,820.08,95.76Q680.76,158.29,539.55,216.4c-77.29,31.8-159.66,66.27-244.08,70.71-65.78,3.46-115.62-16.82-176.63,26.86C44.1,367.48-5.2,453.33.44,547.77a228.38,228.38,0,0,0,14.48,68.72C37.1,673.84,75.26,704.13,120.53,723Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1475.55,1275.83H899.23V756.68a40.43,40.43,0,0,1,40.43-40.43h495.47a40.43,40.43,0,0,1,40.42,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1410.72,1275.83H834.4V756.68a40.43,40.43,0,0,1,40.43-40.43h495.46a40.43,40.43,0,0,1,40.43,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2076.58,186.27a5.88,5.88,0,0,0-11.4-.59c-17.12,56.62-66.65,203.68-139.88,280.78-119.23,125.53-201,331.62-128.46,440.66C1796.84,907.12,2204,840.62,2076.58,186.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2063.35,267.29c-.19,1.78-.5,3.33-.76,5l-.87,4.83-1.85,9.63c-1.27,6.42-2.61,12.82-4,19.21q-4.12,19.18-8.68,38.26c-6.08,25.43-12.83,50.71-20,75.87s-14.88,50.15-23.16,75l-3.09,9.31-3.21,9.27c-2.17,6.17-4.22,12.38-6.49,18.51l-6.69,18.45-7,18.35a1274.05,1274.05,0,0,1-64.93,142.87c-1.5,2.9-3.1,5.76-4.71,8.6l-4.82,8.56-4.82,8.55c-1.64,2.83-3.35,5.62-5,8.43-3.4,5.6-6.66,11.27-10.17,16.79l-10.61,16.52a693.69,693.69,0,0,1-47,62.85.67.67,0,0,1-1-.85h0a744.92,744.92,0,0,0,45.72-63.49l10.4-16.57c3.44-5.55,6.64-11.24,10-16.84,1.64-2.82,3.32-5.62,4.92-8.45l4.71-8.58,4.71-8.57c1.58-2.86,3.15-5.72,4.62-8.63l9-17.37c3-5.8,5.78-11.69,8.67-17.54,1.43-2.93,2.9-5.84,4.3-8.79l4.12-8.87,4.12-8.88c1.39-2.95,2.75-5.91,4-8.91,10.73-23.79,20.52-48,30.06-72.28,18.91-48.66,35.31-98.27,50.15-148.34q11.06-37.58,20.66-75.56,4.83-19,9.27-38.06c1.46-6.37,2.89-12.73,4.26-19.12l2-9.58.95-4.8c.28-1.59.62-3.25.81-4.72l0-.14a.66.66,0,0,1,.74-.57A.67.67,0,0,1,2063.35,267.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.75,7.29a8.45,8.45,0,0,1,13.62-5.46c78.5,61.93,520.61,441,239.42,919.76C475.79,921.59,120.5,747,222.75,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.64,98.2a1.47,1.47,0,0,1,2,.58c15.38,28,30.16,56.33,44.71,84.78s28.73,57.06,42.59,85.84C377.65,327,404.1,385.14,428.74,444.11s47.5,118.72,67.09,179.62q14.84,45.63,26.3,92.32c7.57,31.11,13.92,62.58,17.75,94.48a3.47,3.47,0,0,1-6.89.83v0c-3.62-31.54-9.75-62.81-17.11-93.77s-16-61.66-25.7-92C471,564.75,448.43,505,424.19,446s-50.42-117.26-77.82-174.9q-20.55-43.24-42.11-86c-14.38-28.49-29-56.87-44.21-84.91h0A1.47,1.47,0,0,1,260.64,98.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47,497a4.38,4.38,0,0,1,8.46-.78c14.37,41.59,55.48,149.46,112.16,204.63,92.29,89.83,159.11,240.63,108.34,323.81C275.93,1024.66-28.62,987.1,47,497Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.53,556.77c.19,1,.49,2.26.76,3.41l.88,3.53,1.83,7,3.8,14q3.9,14,8.13,28,8.37,27.9,17.76,55.47c12.63,36.71,26.22,73.09,41.74,108.65,7.84,17.74,15.75,35.45,24.4,52.81s17.69,34.5,27.41,51.28c19.3,33.6,41.14,65.8,66.45,95.24a.87.87,0,0,1-1.29,1.16,501.69,501.69,0,0,1-37.12-45.14c-11.45-15.79-22-32.22-32.06-48.91A932.3,932.3,0,0,1,130.62,779c-7.73-17.88-14.88-36-21.76-54.23s-13.36-36.59-19.3-55.13-11.69-37.14-16.87-55.9q-3.87-14.09-7.43-28.24c-1.17-4.72-2.34-9.44-3.43-14.19l-1.59-7.13-.76-3.57c-.23-1.22-.49-2.34-.68-3.74a.85.85,0,0,1,.73-1,.86.86,0,0,1,1,.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1559.37,512.37h388.7a40.42,40.42,0,0,1,40.42,40.42v694.68a0,0,0,0,1,0,0H1518.94a0,0,0,0,1,0,0V552.79A40.42,40.42,0,0,1,1559.37,512.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1498.76,512.37h388.7a40.42,40.42,0,0,1,40.42,40.42v694.68a0,0,0,0,1,0,0H1458.34a0,0,0,0,1,0,0V552.79A40.42,40.42,0,0,1,1498.76,512.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M444,445.84H806.19a40.42,40.42,0,0,1,40.42,40.42v790.53a0,0,0,0,1,0,0h-443a0,0,0,0,1,0,0V486.26A40.42,40.42,0,0,1,444,445.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M386.84,445.84H749a40.42,40.42,0,0,1,40.42,40.42v790.53a0,0,0,0,1,0,0h-443a0,0,0,0,1,0,0V486.26A40.42,40.42,0,0,1,386.84,445.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M502.85,568.17c66.52,15.34,113.38-.87,158.61-45.13A10.52,10.52,0,0,0,664,512l-.78-2.24a10.51,10.51,0,0,0-16.51-4.7C605.83,538,573.9,558.9,506.94,547.56a10.51,10.51,0,0,0-12,12.7h0A10.53,10.53,0,0,0,502.85,568.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M521.46,591.15l-44.68-35.09a2.29,2.29,0,0,1,.49-3.9l50.08-21.9a2.65,2.65,0,0,1,3.71,2.7c-6.95,20-8.61,38.84-5.92,56.64A2.28,2.28,0,0,1,521.46,591.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M818.09,248.76c28.72,46.79,64.43,64.52,115.32,65.51a8.47,8.47,0,0,0,7.77-4.74l.84-1.71a8.45,8.45,0,0,0-6.61-12.12c-41.95-4.9-71.94-11.43-103.19-56.22a8.45,8.45,0,0,0-14,.28h0A8.45,8.45,0,0,0,818.09,248.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M815.41,272.39,810.33,227a1.85,1.85,0,0,1,2.52-1.92l40.8,16.37a2.13,2.13,0,0,1,.53,3.65c-15.4,7.31-27.12,17-35.81,28.54A1.83,1.83,0,0,1,815.41,272.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1589.5,535.63c25.77,46.94,59.73,65.89,109.26,69.25a8.26,8.26,0,0,0,7.8-4.24l.9-1.63a8.25,8.25,0,0,0-5.87-12.12c-40.65-6.75-69.56-14.52-97.9-59.64a8.24,8.24,0,0,0-13.69-.38h0A8.26,8.26,0,0,0,1589.5,535.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1585.77,558.52,1583,514a1.8,1.8,0,0,1,2.54-1.75l39,17.87a2.08,2.08,0,0,1,.35,3.58c-15.35,6.4-27.22,15.25-36.23,26.12A1.78,1.78,0,0,1,1585.77,558.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M547.48,1275.51H98.84V977.37a40.42,40.42,0,0,1,40.42-40.43h367.8a40.43,40.43,0,0,1,40.42,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.28,1275.51H31.63V977.37a40.43,40.43,0,0,1,40.43-40.43H439.85a40.43,40.43,0,0,1,40.43,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2120.87,1273.61H1669.2V866.15a40.43,40.43,0,0,1,40.43-40.43h370.82a40.43,40.43,0,0,1,40.42,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2070.06,1273.61H1618.39V866.15a40.43,40.43,0,0,1,40.43-40.43h370.82a40.43,40.43,0,0,1,40.42,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1872.06,342.7l251,10.88a26,26,0,0,1,24.9,25.81l2.75,364.67A19.18,19.18,0,0,1,2131,763.39l-287.88-7.24a18.22,18.22,0,0,1-17.75-19l15.88-366.21A29.54,29.54,0,0,1,1872.06,342.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1885.48,752.1h-.06l-32.17-1.81a20.19,20.19,0,0,1-19-20.94l2.11-48.6a1,1,0,1,1,2,.09l-2.11,48.59a18.17,18.17,0,0,0,17.07,18.86l32.17,1.81a1,1,0,0,1,.94,1.06A1,1,0,0,1,1885.48,752.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1838.05,666.74h0a1,1,0,0,1-1-1l.35-7.87a1,1,0,0,1,1-1,1,1,0,0,1,1,1l-.34,7.87A1,1,0,0,1,1838.05,666.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1873,339.79c34.07,6.13,151.31,25.62,249.07,22.36a7.93,7.93,0,0,1,8.21,7.85l3.59,366.33a9.14,9.14,0,0,1-9,9.22c-41.09.65-210.27,2.71-270.2-6.2a7.25,7.25,0,0,1-6.16-7.44l14.39-384A8.57,8.57,0,0,1,1873,339.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1876.22,349.43c32.79,5.9,145.61,24.65,239.69,21.52a7.64,7.64,0,0,1,7.91,7.55L2127.26,731a8.78,8.78,0,0,1-8.64,8.87c-39.54.63-202.36,2.61-260-6a7,7,0,0,1-5.92-7.15l13.84-369.54A8.25,8.25,0,0,1,1876.22,349.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2101,401.16c2.2.1,4-1,4-2.36s-1.76-2.64-4-2.77l-88.34-5.41c-2.2-.14-3.52,1.3-3,3.19a5.79,5.79,0,0,0,5,3.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2012.17,404.68c-2.2-.14-3.52,1.3-3,3.19a5.81,5.81,0,0,0,5,3.62l86.17,3.73c2.2.1,4-1,4-2.36s-1.76-2.64-3.95-2.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2011.55,418.94c-2.2-.14-3.52,1.3-3,3.19a5.79,5.79,0,0,0,5.05,3.62l86.16,3.73c2.2.1,4-1,4-2.36s-1.77-2.64-4-2.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2107.33,459.31c2.2.09,4-1,3.94-2.36s-1.86-2.63-4.05-2.75l-209.88-10.75c-2.2-.11-2.94,1.25-1.64,3l.39.54a9.44,9.44,0,0,0,6.35,3.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1896.73,457.51c-2.2-.12-2.94,1.25-1.64,3l.39.54a9.47,9.47,0,0,0,6.35,3.41l204.89,8.88c2.2.09,4-1,3.94-2.37s-1.86-2.63-4-2.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1929.4,529.13h-.08l-28.27-.58a7.66,7.66,0,0,1-7.75-6.61l-2.22-23.74a5.25,5.25,0,0,1,1.27-3.92,6.29,6.29,0,0,1,4.4-2.11h0c2.39-.13,5.67-.38,9.29-.65,7.88-.58,16.8-1.24,22-1.25h.12a8,8,0,0,1,7.81,5.67c1.41,5.47,1.17,15.78.77,26.77C1936.65,526.31,1933.34,529.18,1929.4,529.13Zm-32.52-34.65a4,4,0,0,0-2.78,1.31,3,3,0,0,0-.73,2.19l2.23,23.75a5.38,5.38,0,0,0,5.5,4.52l28.27.58h.05c2.71,0,5-1.85,5-4.21.4-10.8.64-20.93-.7-26.1a5.69,5.69,0,0,0-5.68-3.94c-5.16,0-14.43.69-21.88,1.24-3.63.27-6.93.52-9.33.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1899.89,496.89c5.95-.34,18.87-1.51,25-1.52a5.48,5.48,0,0,1,5.44,3.84c1.13,4.38.88,13.09.59,21.13a4.7,4.7,0,0,1-5,4.24l-22.59-.46a5.23,5.23,0,0,1-5.3-4.45l-1.78-19A3.67,3.67,0,0,1,1899.89,496.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1956.16,504.85a2.85,2.85,0,0,0-3,3.74l1.62,6.41a5.49,5.49,0,0,0,5,3.92l139,1.52a3.9,3.9,0,0,0,4-4l0-2.55a4.24,4.24,0,0,0-4-4.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1901.06,500.62h0a4.33,4.33,0,0,1,6,1.7l5.47,10.05a1.39,1.39,0,0,0,2.49-.08l14.17-30.64a1.54,1.54,0,0,1,2.94.7,60.77,60.77,0,0,1-18.15,42.11s-8.26-3.31-14.78-18.05A4.56,4.56,0,0,1,1901.06,500.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1928.74,589.72h-.08l-28.27-.58a7.66,7.66,0,0,1-7.75-6.61l-2.23-23.74a5.26,5.26,0,0,1,1.28-3.92,6.29,6.29,0,0,1,4.4-2.11h0c2.38-.13,5.67-.38,9.29-.65,7.87-.58,16.8-1.24,22-1.25h.12a8,8,0,0,1,7.8,5.67c1.42,5.47,1.18,15.79.77,26.77C1936,586.9,1932.68,589.77,1928.74,589.72Zm-32.52-34.65a4,4,0,0,0-2.78,1.31,3,3,0,0,0-.73,2.19l2.23,23.75c.23,2.51,2.6,4.46,5.5,4.52l28.27.58h0c2.7,0,5-1.85,5-4.21.39-10.8.64-20.93-.7-26.1a5.73,5.73,0,0,0-5.68-3.94c-5.16,0-14.43.69-21.88,1.24-3.63.27-6.93.52-9.33.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1899.23,557.48c5.94-.34,18.87-1.51,25-1.52a5.47,5.47,0,0,1,5.43,3.84c1.14,4.39.89,13.09.59,21.13a4.69,4.69,0,0,1-5,4.24l-22.58-.46a5.23,5.23,0,0,1-5.3-4.45l-1.78-19A3.68,3.68,0,0,1,1899.23,557.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1955.5,565.44a2.85,2.85,0,0,0-3,3.74l1.62,6.41a5.47,5.47,0,0,0,5,3.92l139,1.52a3.9,3.9,0,0,0,4-3.95l0-2.55a4.24,4.24,0,0,0-4-4.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1900.39,561.21h0a4.34,4.34,0,0,1,6,1.7l5.47,10.05a1.39,1.39,0,0,0,2.49-.08l14.16-30.64a1.55,1.55,0,0,1,3,.7,60.82,60.82,0,0,1-18.15,42.11s-8.26-3.31-14.78-18A4.55,4.55,0,0,1,1900.39,561.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1925.45,647.88h-.07l-28.27-.59c-4.07-.08-7.41-2.92-7.75-6.6l-2.23-23.75a5.24,5.24,0,0,1,1.28-3.92,6.29,6.29,0,0,1,4.4-2.11h0c2.38-.13,5.66-.38,9.28-.64,7.49-.56,16.81-1.25,22.05-1.26a8.06,8.06,0,0,1,7.92,5.68c1.42,5.47,1.17,15.78.77,26.76C1932.7,645.05,1929.4,647.92,1925.45,647.88Zm-32.51-34.66a3.93,3.93,0,0,0-2.78,1.31,2.91,2.91,0,0,0-.73,2.19l2.23,23.75c.23,2.52,2.6,4.46,5.5,4.52l28.26.58c2.67,0,5-1.83,5.11-4.21.39-10.8.63-20.92-.7-26.1a5.79,5.79,0,0,0-5.69-3.94c-5.16,0-14.43.69-21.88,1.25-3.63.26-6.93.51-9.32.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1896,615.63c5.94-.34,18.86-1.51,25-1.52a5.47,5.47,0,0,1,5.43,3.85c1.14,4.38.88,13.08.59,21.12a4.71,4.71,0,0,1-5,4.25l-22.59-.47a5.21,5.21,0,0,1-5.29-4.44l-1.78-19A3.67,3.67,0,0,1,1896,615.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1952.22,623.59a2.85,2.85,0,0,0-3,3.74l1.61,6.41a5.5,5.5,0,0,0,5,3.93l139,1.52a3.92,3.92,0,0,0,4-4l0-2.55a4.25,4.25,0,0,0-4-4.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1897.11,619.36h0a4.35,4.35,0,0,1,6,1.7l5.47,10.05A1.39,1.39,0,0,0,1911,631l14.17-30.64a1.55,1.55,0,0,1,3,.7A60.81,60.81,0,0,1,1910,643.21s-8.25-3.32-14.77-18.06A4.56,4.56,0,0,1,1897.11,619.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1921.59,707.84h-.08l-28.27-.58a7.67,7.67,0,0,1-7.75-6.61l-2.23-23.75a5.25,5.25,0,0,1,1.28-3.91,6.29,6.29,0,0,1,4.4-2.11h0c2.38-.14,5.67-.38,9.29-.65,7.87-.58,16.8-1.25,22-1.25,3.84.09,7.06,2.32,7.92,5.67,1.42,5.47,1.18,15.78.77,26.76C1928.83,705,1925.53,707.88,1921.59,707.84Zm-32.52-34.66a4,4,0,0,0-2.78,1.31,3,3,0,0,0-.73,2.2l2.23,23.74c.23,2.52,2.6,4.46,5.5,4.52l28.27.58h0c2.7,0,5-1.84,5.05-4.2.39-10.8.64-20.93-.7-26.1a5.81,5.81,0,0,0-5.68-4c-5.16,0-14.43.7-21.88,1.25-3.63.27-6.93.51-9.33.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1892.08,675.6c5.94-.35,18.87-1.51,25-1.52a5.45,5.45,0,0,1,5.43,3.84c1.14,4.38.89,13.09.59,21.12a4.7,4.7,0,0,1-5,4.25l-22.58-.46a5.23,5.23,0,0,1-5.3-4.45l-1.78-19A3.67,3.67,0,0,1,1892.08,675.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1948.35,683.56a2.85,2.85,0,0,0-3,3.74l1.62,6.41a5.47,5.47,0,0,0,5,3.92l139,1.52a3.9,3.9,0,0,0,4-3.95l0-2.55a4.23,4.23,0,0,0-4-4.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1893.24,679.33h0a4.34,4.34,0,0,1,6,1.69l5.47,10.06a1.39,1.39,0,0,0,2.49-.08l14.16-30.64a1.55,1.55,0,0,1,3,.7,60.82,60.82,0,0,1-18.15,42.11s-8.26-3.31-14.78-18A4.55,4.55,0,0,1,1893.24,679.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2015.26,299.21c-8.79-6.7-16.68-6.92-22.3-5.52A11.08,11.08,0,0,0,1984.6,305l1.26,26.23,28.37,3.76S2032.51,312.35,2015.26,299.21Zm-13.43,20.53a7.11,7.11,0,1,1,7.41-6.8A7.11,7.11,0,0,1,2001.83,319.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1988.67,321a1.45,1.45,0,0,1-.93-1.09l-.49-3.48a1,1,0,0,1,1.2-1.13,1.57,1.57,0,0,1,1.53,1.22l.49,3.48c.09.65-.45,1.15-1.2,1.13A1.74,1.74,0,0,1,1988.67,321Zm-1-6.83a1.46,1.46,0,0,1-.93-1.08l-.37-2.65c-.63-4.48,2.5-8.24,7.46-8.94a25.17,25.17,0,0,1,10.46.78,1.4,1.4,0,0,1,1.11,1.49,1.19,1.19,0,0,1-1.59.73,22.13,22.13,0,0,0-9.13-.68c-3.71.53-6.06,3.35-5.58,6.71l.37,2.64a1.06,1.06,0,0,1-1.2,1.14A1.75,1.75,0,0,1,1987.71,314.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1946.26,346.4l.57-13.13a8,8,0,0,1,8.64-7.65l90.41,7a7.8,7.8,0,0,1,7.19,7.65l.21,12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1980.76,332h0l-3.89-.16a1,1,0,0,1-1-1.05,1,1,0,0,1,1-.95l3.9.17a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1950.83,343.11a1.43,1.43,0,0,1-.87-1.37l.23-5.31a8.17,8.17,0,0,1,8.52-7.81l14.32.62a1.41,1.41,0,1,1-.12,2.82l-14.32-.62a5.35,5.35,0,0,0-5.58,5.11l-.23,5.32a1.42,1.42,0,0,1-1.47,1.35A1.53,1.53,0,0,1,1950.83,343.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1918.1,340.37l158.33,6.86a11.71,11.71,0,0,1,11.11,10.2l.1.78a10.06,10.06,0,0,1-10.41,11.34l-162.44-7a6.55,6.55,0,0,1-6.23-7.14l.67-7.25A8.53,8.53,0,0,1,1918.1,340.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1871.47,529.6l-229.79,40.86a16.8,16.8,0,0,0-13.32,20.75l.41,1.55a15.6,15.6,0,0,0,19.12,11.17l226.75-60.36Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 1979.04,
    cy: 499.67,
    rx: 106.31,
    ry: 108.27,
    transform: "translate(1146.04 2363.1) rotate(-80.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1999.42,383.13c-65.54-11.46-127.8,31.43-139.05,95.79s32.76,125.82,98.3,137.28,127.79-31.43,139-95.79S2065,394.59,1999.42,383.13Zm-37.76,216c-55.91-9.78-93.46-62.21-83.86-117.12s62.71-91.48,118.62-81.71,93.46,62.21,83.86,117.12S2017.57,608.85,1961.66,599.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1866.84,494.53a.43.43,0,0,1-.26-.42c.13-2.81.37-5.66.72-8.45a.43.43,0,0,1,.48-.38.43.43,0,0,1,.38.48c-.35,2.78-.59,5.6-.72,8.39a.42.42,0,0,1-.45.41A.37.37,0,0,1,1866.84,494.53Zm6.51-32.44a.44.44,0,0,1-.24-.55,109.21,109.21,0,0,1,10.2-20.72,110.94,110.94,0,0,1,48.72-42,114.44,114.44,0,0,1,122.66,19.34.43.43,0,1,1-.58.64,113,113,0,0,0-56.17-27.23c-45.09-7.88-89.8,11.63-113.9,49.71a108.08,108.08,0,0,0-10.11,20.56.44.44,0,0,1-.56.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1741.63,661.21l-24.43,6.1,6.11,45.8s-9.16,9.16-12.21,21.37-5.87,63.5-5.87,63.5l-5.8,3.5-.7,2.92,16.86,22.68-2.8-18.05c-.44-2.86.33-8.67.09-8.79,9.15-24.43,28.75-93.24,28.75-93.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1748.76,804.72c-.26,0-.52,0-.79,0,1.18-14.73,6.58-79.53,12-103.82,6.1-27.48-9.16-82.44-9.16-82.44l-27.48,27.48,15.26,51.91c-10.46,15.69,1.71,107.59,1.45,107.55l0,.2-4,5.48.49,3,24.33,14.36-9.57-15.55A17.6,17.6,0,0,1,1748.76,804.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1717.86,496.59s-53.5,74.24,0,112.31l5.45-4.86s-26.56-31.32,0-69.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1762.47,830.66h-7.76a4.66,4.66,0,0,1-3.71-1.82c-2.42-3.15-7.44-9.28-9.84-9.44-3.23-.22-2.81,11.26-2.81,11.26h-1.81l-2.3-14.26a8.46,8.46,0,0,1,4.43-8.83h0s.74,5.46,4.74,7.87,16.29,11.06,16.29,11.06a11.19,11.19,0,0,1,3.16.09A2.05,2.05,0,0,1,1762.47,830.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1716.19,829.77l-7.16-3a4.66,4.66,0,0,1-2.71-3.11c-1-3.84-3.26-11.44-5.4-12.52-2.9-1.45-7,9.29-7,9.29l-1.66-.7,3.41-14a8.46,8.46,0,0,1,7.51-6.42h0s-1.44,5.32,1.31,9.1,10.73,16.51,10.73,16.51a10.8,10.8,0,0,1,2.87,1.3A2.05,2.05,0,0,1,1716.19,829.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1757.79,572s-.9,5.5.41,20.63,7.61,50.65,6.33,84.64c0,0-17.88,4.17-48.94,2.19,0,0-13.11-53.06-9.92-73.23s20.52-34.65,20.52-34.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "1744.58 470.9 1746.76 496.59 1726 496.59 1731.16 457.37 1744.58 470.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1719.85,493c7.17-.4,23.18-1.13,34.53-.51a13.18,13.18,0,0,1,12.2,10.47l2.77,13.27a31.9,31.9,0,0,1-.45,14.92L1757.79,572s-9.89,5.94-31.6-.42c0,0-19.06-45.46-11.26-74.54A5.41,5.41,0,0,1,1719.85,493Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1766,500.62c3.06,8.06,5.82,16.5,8.79,24.41,1.51,4,3,7.84,4.67,11.41.83,1.77,1.74,3.41,2.58,4.88a21.09,21.09,0,0,0,2.26,3.25c.1.08-.22.14-.33.15s2.07.35,2.72.46l2.56,0a89,89,0,0,0,12-1.64c8.39-1.57,17.12-3.76,26.08-5.42l.07,0a3.16,3.16,0,0,1,2.66,5.48,91.37,91.37,0,0,1-11.41,8.33q-3,1.85-6.11,3.57c-2.1,1.08-4.22,2.16-6.42,3.16a74.29,74.29,0,0,1-14.25,4.85c-1.38.23-2.75.47-4.17.66a46.86,46.86,0,0,1-4.79.1c-.92-.09-1.85-.21-2.78-.34a14.23,14.23,0,0,1-1.46-.26c-.63-.2-1.27-.41-1.89-.64a19.75,19.75,0,0,1-3.22-1.63c-.88-.58-1.68-1.19-2.46-1.81a33.25,33.25,0,0,1-6.24-7.22,57.26,57.26,0,0,1-3.93-7,95.18,95.18,0,0,1-5.41-13.68,127.26,127.26,0,0,1-5.65-27.69,8.31,8.31,0,0,1,16-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1824.52,542.2l3.7-8.79,19.5-4.86s1.56,3.38-6.63,4.86c0,0,2.93,3.23,1.37,7S1824.33,548.05,1824.52,542.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1753.36,441.23c.75.43,6.59,21,1.69,29.67s-19.84-1-23.89-13.53S1733.62,429.58,1753.36,441.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1714.63,457.37c-3.35,16.43-14.46,11.93-22.33,19.24-12.75,11.84-31-.37-48.72,10.86-12.8,8.1-19,28.83-12.83,45.56,8.51,23.18,37.59,32.72,52.66,25.66,14.4-6.75,12.35-27,31.73-34.77,8.22-3.32,12.28-1.16,17.21-6.07,8.62-8.61,6.3-25.3,5.4-31.73-2-14-6.62-16.48-4.39-22.62,4.35-11.93,24.64-9.46,26.33-17.89,1.54-7.67-13.17-22.2-27-19.91C1711.28,429.24,1716.12,450.06,1714.63,457.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 798.82,
    y: 1239.74,
    width: 9.73,
    height: 105.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M846.29,1347h-85.2v-3.48a2.85,2.85,0,0,1,2.85-2.86h79.27a3.08,3.08,0,0,1,3.08,3.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 748.55,
    y: 1214.69,
    width: 113.85,
    height: 32.29,
    rx: 11.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M749.5,1326.3s-27.77,20-23,33.47c0,0,30.39-13.11,34.06-23.44s-.62-14.89-.62-14.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M753.68,1309.52l4.54,13.13a4.56,4.56,0,0,1-1.77,5.36,11.83,11.83,0,0,1-3.76,1.45,5.31,5.31,0,0,1-5.88-2.67l-5.43-10.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M797.88,1191.33s-57,9.89-81.53,32.5,22.47,94.73,22.47,94.73,7.69,0,17-8c0,0-27.84-54.24-3.85-70.06,27-17.78,58-21.78,58-21.78l-11.59-25.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M731.38,1355.45c6.11-2.11,23.4-11.17,26.32-11.57s8,2.17,8,2.17,1.23,1.65-.08,4.54c-4.06,3.67-13.08,10.67-25.2,13.28-8.91,1.92-15.15.13-19-2A25,25,0,0,1,731.38,1355.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M740.39,1363.6c12.12-3.49,21.14-12.86,25.2-17.77-.89,2.61-2.94,6-7.32,9.9-10.87,9.77-31.62,13.29-36,12.61-3.54-.54-3.21-3.81-.87-7.37C725.24,1363.77,731.48,1366.16,740.39,1363.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M770.85,1331.21c-.07,1.69-3.51,7.46-5.52,10.7a5.22,5.22,0,0,1-4.44,2.48,13.79,13.79,0,0,1-3.67-.44,3.4,3.4,0,0,1-2.28-4.23l3.93-13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M852.8,1174.21s12.67,33.88,0,44.18-42.9,21.9-49.65,42.43-18.21,60.4-33.55,74.53c0,0-10.77-1-14.8-5.34,0,0,8.73-59.54,14.49-74.82,5-13.23,12.34-32.32,26.42-43,4-3,3.33-7.89,1.46-12.59l-3.4-8.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M720.65,1147.65c21.25,1.28,14.63-32.66,14.24-34l32.25,22.78s-1.71,18.15-28.52,27.67a33.27,33.27,0,0,1-18.46,1.33A29.3,29.3,0,0,0,720.65,1147.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M679.57,1137.43c7.92-5.5,16.89,0,16.89,0,10.58,6.93,18.41,9.87,24.19,10.22a29.3,29.3,0,0,1-.49,17.77c-11.86-2.54-20.34-11.13-24-15.53a3.83,3.83,0,0,0-5.3-.58c-1.65,1.3-3.25,3.08-3,5,.57,3.7-3.72,4.88-4,3.53s1.46-9.29,1.46-9.29-8.58,8.63-11.93,12-7.57,0-7.57,0S671.65,1142.94,679.57,1137.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M819.72,1061.22s-30.91-12.37-88.44,35.12c0,0-4.8,9.94.44,18.79s55.19,52,62,75.91c0,0,29.75,9.66,60.52-13.26C854.29,1177.78,851.58,1111.21,819.72,1061.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M758.61,1050.18l15.22,18.44a6.07,6.07,0,0,1,.8,6.51c-2.12,4.31-7.13,10.58-18.24,9.72a9.36,9.36,0,0,1-7.68-5.24l-10.64-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M843.64,1140.22c3.59-14.61-32.75-47.19-32.75-47.19l8.83-31.81s78.47,52.25,58.48,94.26a30.65,30.65,0,0,1-11.09,13.06C860.79,1151.53,850.72,1143.73,843.64,1140.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M843.67,1138.09a.85.85,0,0,0,.83-.65c3.67-14.94-31.51-46.69-33-48a.88.88,0,0,0-1.22.07.86.86,0,0,0,.07,1.21c.36.33,35.92,32.4,32.5,46.35a.85.85,0,0,0,.63,1A.65.65,0,0,0,843.67,1138.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M788.6,1139s43.09,16.73,53.61,4.15a7.07,7.07,0,0,0,1.43-2.89c7.08,3.51,17.15,11.31,23.47,28.32-22.67,14.48-61.41-8-71.88-14.7a7.85,7.85,0,0,0-5.79-1.06c-4,.84-11,2.07-14.78,1.49-5.51-.85-13.42,18.58-22.34,12.58C752.32,1166.85,760,1133.09,788.6,1139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M720.66,1029s-.27,20.09,3,29.21,3.75,15.71,14.81,13.18S756,1060,757,1049.17c0,0,1.63-16.77-2.38-21.68S720.66,1029,720.66,1029Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M750.81,1044.27l-1.3.55s.74-13.27-4.78-13.22-25.82,4.08-32.63-.86c-6.57-4.76-6.57-14.47-2.36-19a.75.75,0,0,1,1,0l.77.63a.76.76,0,0,0,1.24-.68h0a.75.75,0,0,1,1.17-.71c2.07,1.46,6.77,3.28,16.42,1.17,13.7-3,24.27-1.37,28.17,7.33a.76.76,0,0,0,1.32.12c.7-1,2.09-1.87,4.81-1,4.72,1.47,6.49,9.68,1.47,19.16a.75.75,0,0,0,.5,1.11c1.77.32,4.74,1.6.58,6.72s-7.63,6.27-9,6.47a.75.75,0,0,1-.83-.5l-2.79-8a.76.76,0,0,0-1-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M751.18,1046s-1.74-12,4.4-11,2.58,13.22-1.16,15.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M606.83,1365.87a4,4,0,0,1-1.5-.3,3.65,3.65,0,0,1-2-4.84L683,1181.41a3.84,3.84,0,0,1,5-1.93,3.63,3.63,0,0,1,2,4.83l-79.68,179.33A3.82,3.82,0,0,1,606.83,1365.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.6,1365.87a3.8,3.8,0,0,1-3.49-2.23l-79.68-179.33a3.64,3.64,0,0,1,2-4.83,3.86,3.86,0,0,1,5,1.93l79.68,179.32a3.66,3.66,0,0,1-2,4.84A4,4,0,0,1,696.6,1365.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M853.48,1365.87a4,4,0,0,1-1.5-.3,3.64,3.64,0,0,1-2-4.84l79.68-179.32a3.85,3.85,0,0,1,5-1.93,3.63,3.63,0,0,1,2,4.83L857,1363.64A3.82,3.82,0,0,1,853.48,1365.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M943.24,1365.87a3.82,3.82,0,0,1-3.49-2.23l-79.68-179.33a3.63,3.63,0,0,1,2-4.83,3.85,3.85,0,0,1,5,1.93l79.68,179.32a3.64,3.64,0,0,1-2,4.84A4,4,0,0,1,943.24,1365.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M952.59,1175.87a4.4,4.4,0,0,0-.76-3.32,3.44,3.44,0,0,0-2.76-1.45H586.58a4,4,0,0,0-3.48,2.13,5.11,5.11,0,0,0-.26,4.42l3.92,9.52a5.5,5.5,0,0,0,5,3.57H946.58a4.31,4.31,0,0,0,4.09-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M766.52,1172h-.21l-90.41-.1a4,4,0,1,1,0-8.09l90.41.1a4,4,0,0,1,.2,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M594.63,1089.87h75.29a14.34,14.34,0,0,1,13,8.23l34.81,73.81H624.14a8.72,8.72,0,0,1-8.11-5.52l-27-68.3A6,6,0,0,1,594.63,1089.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M647.67,1127.71c1.63,5.07.43,10-2.69,11s-7-2.29-8.6-7.36-.43-10,2.69-11S646,1122.64,647.67,1127.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M423.88,944.45c.3,0,.61,0,.92-.05a8,8,0,0,0,7-8.86L381.64,498.72a8,8,0,0,0-15.89,1.82L416,937.37A8,8,0,0,0,423.88,944.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.94,944.45a8,8,0,0,0,7.8-6.25l97.94-436.82a8,8,0,0,0-15.6-3.5l-98,436.82a8,8,0,0,0,7.81,9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.35,944.45a8,8,0,0,0,8-8V720.87a8,8,0,0,0-16,0V936.45A8,8,0,0,0,313.35,944.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M473.38,450.76,445.27,804.89a14.14,14.14,0,0,1-14.45,13l-293.65-7.16a14.15,14.15,0,0,1-13.63-16.37l56.22-353.11a14.15,14.15,0,0,1,14.3-11.93l265.55,6.15A14.15,14.15,0,0,1,473.38,450.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M448.8,445.24l-246.24-5.7a14.17,14.17,0,0,0-14.31,11.92l-53,333.21A14.15,14.15,0,0,0,148.84,801l272.76,6.65a14.15,14.15,0,0,0,14.45-13l26.53-334.15A14.15,14.15,0,0,0,448.8,445.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.92,479.32,440,486.24a2.26,2.26,0,0,1,2.12,2.45l-.17,2a2.25,2.25,0,0,1-2.41,2.06l-123.94-8.91a2.26,2.26,0,0,1-2.09-2.45h0A2.26,2.26,0,0,1,315.92,479.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M312.65,491.76l-.07.85a2.26,2.26,0,0,0,2.05,2.45l123.79,10.62a2.26,2.26,0,0,0,2.45-2.06l.07-.85a2.25,2.25,0,0,0-2.06-2.44L315.09,489.7A2.26,2.26,0,0,0,312.65,491.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.27,506.08l0,.38a2.25,2.25,0,0,0,2.05,2.44l86.22,7.4a2.26,2.26,0,0,0,2.45-2.06l.15-1.75A2.26,2.26,0,0,0,438,510l-86.33-6A2.27,2.27,0,0,0,349.27,506.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M406.84,584.41a1.48,1.48,0,0,1-1-.43l-38.16-37-43.14,26.09a1.49,1.49,0,0,1-2-.42L272,499.93l-57.61,42.16a1.5,1.5,0,0,1-1.77-2.43l58.85-43.06a1.5,1.5,0,0,1,2.12.36l50.54,72.8,42.92-26a1.5,1.5,0,0,1,1.82.21L407,581l23.54-17.17a1.5,1.5,0,0,1,1.77,2.43l-24.56,17.91A1.54,1.54,0,0,1,406.84,584.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.11,613.5H263a1,1,0,0,1-.91-1.08l.13-1.44a1,1,0,0,1,1.09-.91,1,1,0,0,1,.9,1.08l-.12,1.44A1,1,0,0,1,263.11,613.5Zm.74-8.41h-.08a1,1,0,0,1-.91-1.09l.26-3a1,1,0,0,1,1.09-.9,1,1,0,0,1,.9,1.08l-.26,3A1,1,0,0,1,263.85,605.09Zm.88-10h-.09a1,1,0,0,1-.9-1.09l.26-3a1,1,0,1,1,2,.18l-.26,3A1,1,0,0,1,264.73,595.13Zm.88-10h-.09a1,1,0,0,1-.9-1.08l.26-3a1,1,0,1,1,2,.18l-.26,3A1,1,0,0,1,265.61,585.17Zm.88-10h-.09a1,1,0,0,1-.9-1.08l.26-3a1,1,0,1,1,2,.18l-.26,3A1,1,0,0,1,266.49,575.21Zm.88-10h-.09a1,1,0,0,1-.91-1.08l.27-3a1,1,0,0,1,2,.17l-.26,3A1,1,0,0,1,267.37,565.25Zm.88-10h-.09a1,1,0,0,1-.91-1.08l.27-3a1,1,0,0,1,2,.17l-.26,3A1,1,0,0,1,268.25,555.28Zm.88-10H269a1,1,0,0,1-.91-1.09l.27-3a1,1,0,0,1,2,.17l-.26,3A1,1,0,0,1,269.13,545.32Zm.88-10h-.09a1,1,0,0,1-.91-1.09l.27-3a1,1,0,0,1,2,.17l-.26,3A1,1,0,0,1,270,535.36Zm.88-10h-.09a1,1,0,0,1-.91-1.09l.27-3a1,1,0,0,1,2,.18l-.27,3A1,1,0,0,1,270.89,525.4Zm.88-10h-.09a1,1,0,0,1-.91-1.09l.27-3a1,1,0,1,1,2,.18l-.27,3A1,1,0,0,1,271.77,515.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.86,616.54h-.09a1,1,0,0,1-.91-1.08v-.15a1,1,0,0,1,1.09-.91,1,1,0,0,1,.9,1.08v.15A1,1,0,0,1,319.86,616.54Zm.62-7.13h-.08a1,1,0,0,1-.91-1.08l.26-3a1,1,0,0,1,1.08-.91,1,1,0,0,1,.91,1.08l-.26,3A1,1,0,0,1,320.48,609.41Zm.88-10h-.09a1,1,0,0,1-.9-1.09l.26-3a1,1,0,1,1,2,.17l-.26,3A1,1,0,0,1,321.36,599.45Zm.88-10h-.09a1,1,0,0,1-.9-1.09l.26-3a1,1,0,0,1,1.08-.9,1,1,0,0,1,.91,1.08l-.26,3A1,1,0,0,1,322.24,589.49Zm.88-10H323a1,1,0,0,1-.9-1.09l.26-3a1,1,0,0,1,2,.18l-.26,3A1,1,0,0,1,323.12,579.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.12,615.58h-.05a1,1,0,0,1-.94-1.05l.17-3a1,1,0,0,1,1.05-.94,1,1,0,0,1,.94,1.06l-.17,3A1,1,0,0,1,363.12,615.58Zm.58-10h-.06a1,1,0,0,1-.94-1.06l.17-3a1,1,0,1,1,2,.11l-.17,3A1,1,0,0,1,363.7,605.6Zm.57-10h-.06a1,1,0,0,1-.94-1.06l.17-3a1,1,0,0,1,1.05-.94,1,1,0,0,1,.94,1.06l-.17,3A1,1,0,0,1,364.27,595.62Zm.57-10h-.06a1,1,0,0,1-.94-1l.17-3a1,1,0,0,1,2,.11l-.17,3A1,1,0,0,1,364.84,585.63Zm.57-10h-.06a1,1,0,0,1-.94-1.06l.17-3a1,1,0,0,1,2,.11l-.17,3A1,1,0,0,1,365.41,575.65Zm.57-10h-.06a1,1,0,0,1-.94-1l.17-3a1,1,0,1,1,2,.12l-.17,3A1,1,0,0,1,366,565.67Zm.57-10h-.06a1,1,0,0,1-.94-1.06l.17-3a1,1,0,0,1,1-.94,1,1,0,0,1,.94,1l-.17,3A1,1,0,0,1,366.55,555.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M404.24,619.51h-.09a1,1,0,0,1-.91-1.08l.26-3a1,1,0,1,1,2,.18l-.27,3A1,1,0,0,1,404.24,619.51Zm.88-10H405a1,1,0,0,1-.91-1.08l.26-3a1,1,0,0,1,1.09-.91,1,1,0,0,1,.9,1.09l-.26,3A1,1,0,0,1,405.12,609.55Zm.88-10h-.09a1,1,0,0,1-.91-1.08l.26-3a1,1,0,0,1,1.09-.91,1,1,0,0,1,.9,1.08l-.26,3A1,1,0,0,1,406,599.59Zm.87-10h-.08a1,1,0,0,1-.91-1.08l.26-3a1,1,0,0,1,1.09-.91,1,1,0,0,1,.9,1.08l-.26,3A1,1,0,0,1,406.87,589.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.23,615.1h-.15a1.5,1.5,0,0,1-1.35-1.64l13.41-134.08a1.5,1.5,0,1,1,3,.3L203.72,613.74A1.51,1.51,0,0,1,202.23,615.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "209.98 484.96 215.54 480.4 220.1 485.97 220.53 481.67 215.97 476.11 210.41 480.66 209.98 484.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M431.6,628.88h-.13l-237.55-21a1.5,1.5,0,0,1,.26-3l237.55,21a1.5,1.5,0,0,1-.13,3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "425.2 631.92 430.72 627.3 426.09 621.79 430.4 622.17 435.01 627.68 429.5 632.3 425.2 631.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M233.05,942.57a2.12,2.12,0,0,0-.07-.66c-3.31-13.14-19.76-21.32-19.76-21.32l-6.51.51c-3.75,11.58-3.27,18.68-2.67,21.84a2,2,0,0,0,.07.26A154.06,154.06,0,0,0,233.05,942.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M204.11,943.2a2.82,2.82,0,0,0,2.07,2.09c7.64,1.61,19.8.32,24.9-.35a2.38,2.38,0,0,0,2-2.37A154.06,154.06,0,0,1,204.11,943.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M299.1,519.13,342,503.55l3.31,6.93L304.08,526S298.34,525.52,299.1,519.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M342,503.55c-1.26,3.83,3.31,6.93,3.31,6.93l7.79-5.51a14.61,14.61,0,0,1-.82-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M352.31,501.93a14.61,14.61,0,0,0,.82,3l5.75-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M178.3,710c-4,4.3-10,8-14.12,10.33,6.22,7.69,14.65,15.4,25.81,22.95l3.19,7.17,10.23-12.27S185.06,729.05,178.3,710Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M204.08,911.39l2.76,13.29a2.2,2.2,0,0,0,1.86,1.79,18.89,18.89,0,0,0,4.28-.07,2.74,2.74,0,0,0,2.16-3.21l-1.92-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M261.28,943.07c-7.2-.2-10.92-1.05-12.85-1.84,0,.72,0,1.45,0,2.2a1.42,1.42,0,0,0,1.35,1.45l39.52-.26a1.81,1.81,0,0,0,1.46-2.63C285.6,942.42,272.41,943.38,261.28,943.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M290.79,942a1.64,1.64,0,0,0-.16-.29c-3.49-4.88-12.38-14.59-29.95-18.8l-8.42-.27s-3.76,6.52-3.83,18.6c1.93.79,5.65,1.64,12.85,1.84C272.41,943.38,285.6,942.42,290.79,942Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M250.69,909.86c.1.63,1.25,10.17,1.7,13.88a1.83,1.83,0,0,0,1.55,1.65,19.18,19.18,0,0,0,5.78-.09,2.49,2.49,0,0,0,1.89-2.5v-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M243.93,735.63s20.33,77.24,20,174.45a3.77,3.77,0,0,1-3,3.67,45,45,0,0,1-9.43,1.09,3.49,3.49,0,0,1-3.32-2.92c-2.85-16.71-19.21-110.87-28.53-126.15,0,0-6.13,83.86-4.17,127.36a2.07,2.07,0,0,1-1.82,2.15,34.68,34.68,0,0,1-7.56,0,2.77,2.77,0,0,1-2.46-2.35c-2-14.14-13.72-98.34-13.22-159,0-3.42,9-18.29,9-18.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M310.4,569.29c-8.92,16.61-23.73,33.55-47.83,38.09-22.25,4.2-62.19,9.38-78.25,11.4a19.69,19.69,0,0,0-12.43,6.67c-12.62,14.61-40.31,54.59-7.71,94.88,4.17-2.32,10.09-6,14.12-10.33-3.61-10.16-3.9-23.15,3.65-39.08a37.34,37.34,0,0,0,1,3.74c10.42,33,11,60.46,11,66.78a2.09,2.09,0,0,0,1.31,2c13.71,5.49,40.09,2.22,48.95.9a3,3,0,0,0,2.49-3.38c-4.34-31.5,18-83.31,23.86-96.28a8.6,8.6,0,0,1,4.28-4.29c33.7-15.24,48.35-38.71,54.29-59.85C323.91,573.6,316,570.59,310.4,569.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M329.05,580.5a102.27,102.27,0,0,0,1.6-47.82H323a124.16,124.16,0,0,1-12.57,36.61C316,570.59,323.91,573.6,329.05,580.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M325.67,536.76s-11.68-15.14-7.89-23,16.82-7.12,16.82-7.12l1.83,6.18a7.77,7.77,0,0,1-.19,5l-7.19,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M208,588.48l-2.64,27s15.19,4.58,26.23-3.22l-7.76-24.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M225.63,557.71c.37.35,15.43,29.92,15.43,29.92L224,595.87,205.55,570S219.51,552,225.63,557.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M213.1,570.68a2.72,2.72,0,0,0,.21,2.39l8.51,14.19a2.39,2.39,0,0,0,.47.58c1,.94,4.48,3.69,7.16-.05,2.28-3.18,4.43-6.07,6.72-7.27a2.73,2.73,0,0,1,3.68,1.21,102.67,102.67,0,0,1,5.82,13.82,2.7,2.7,0,0,1-1.58,3.32,75,75,0,0,1-16.34,4.77,2.73,2.73,0,0,1-2.58-1.09c-2.6-3.57-9.95-13.56-12.46-16.06-2.33-2.32-6.63-1.44-8.57-.89a2.73,2.73,0,0,1-2.18-.28c-2-1.19-5.4-4.14-2.26-9.13a2.72,2.72,0,0,0-.84-3.7c-2.19-1.44-4.58-4.16-2.31-8.55s6.4-4.84,9.2-4.5a2.81,2.81,0,0,0,3-1.65,1.82,1.82,0,0,1,1.41-1.1,2.65,2.65,0,0,0,2.14-3.11c-.5-2.51-.12-5.78,3.89-8,7.37-4.05,13.82,2.54,15.46,8.11s-6.6,9.51-11.78,10.16C216,564.36,213.94,568.51,213.1,570.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M215.9,591.7s-3.27-9.58-7.46-9.23-7.49,4.53-2.3,9.23C212.6,597.53,215.9,591.7,215.9,591.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M180.57,668.45c-5.52-15.12-3.52-33.38-3.5-33.56l1.52.17c0,.18-2,18.09,3.42,32.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 625.47,
    cy: 999.37,
    r: 62.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 625.58,
    cy: 999.88,
    r: 54.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M675.71,1036.14l-66.3-66.3-7,6.4L662.77,1048l.42.47,2.13,2.33c3.67,4,8.82,5.23,11.52,2.76l3.2-2.94c2.7-2.47,1.91-7.71-1.76-11.71l-2.13-2.33Zm-1.21,11.66c-1.79,1.64-5.48.53-8.24-2.48s-3.54-6.78-1.76-8.42,5.48-.53,8.24,2.48S676.28,1046.16,674.5,1047.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M591.29,943l12.39,13.51a4.19,4.19,0,0,1,1.05,3.56l-1.15,6.6a4.22,4.22,0,0,1-3.78,3.47l-6.67.57a4.19,4.19,0,0,1-3.46-1.35l-12.4-13.51a3.23,3.23,0,0,0-5.6,1.8,24.25,24.25,0,0,0,6.33,18.9c8.91,9.71,22.62,9.45,32,.88s10.79-22.21,1.88-31.93a24.23,24.23,0,0,0-18.28-7.93A3.24,3.24,0,0,0,591.29,943Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M590,944.18l12.39,13.52a4.18,4.18,0,0,1,1,3.56l-1.14,6.59a4.2,4.2,0,0,1-3.79,3.47l-6.66.58a4.25,4.25,0,0,1-3.47-1.35L576,957a3.23,3.23,0,0,0-5.6,1.8,24.14,24.14,0,0,0,6.33,18.89c8.91,9.72,22.62,9.46,32,.88s10.79-22.2,1.88-31.92a24.17,24.17,0,0,0-18.28-7.93A3.23,3.23,0,0,0,590,944.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M674.7,1037.07l-66.3-66.3-7,6.4,60.34,71.77c.13.16.27.32.41.47l2.14,2.33c3.66,4,8.82,5.23,11.51,2.76l3.21-2.94c2.69-2.47,1.9-7.71-1.76-11.71l-2.14-2.33Zm-1.22,11.66c-1.79,1.64-5.47.53-8.23-2.48s-3.55-6.77-1.76-8.41,5.47-.53,8.23,2.47S675.27,1047.09,673.48,1048.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "612.65 1009.44 617.5 1013.67 661.47 962.24 657.64 958.91 612.65 1009.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M622.44,995.74l7.3,6.38a3.34,3.34,0,0,1,.39,4.65l-37,45.36a7.83,7.83,0,0,1-11.21.94l-3.44-3a7.83,7.83,0,0,1-.58-11.23L617.78,996A3.35,3.35,0,0,1,622.44,995.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 605.62,
    y: 997.02,
    width: 2.45,
    height: 61.06,
    transform: "translate(388.59 2200.79) rotate(-138.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 602.26,
    y: 994.1,
    width: 2.45,
    height: 61.06,
    transform: "translate(384.6 2193.44) rotate(-138.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 598.9,
    y: 991.17,
    width: 2.45,
    height: 61.06,
    transform: "translate(380.67 2186.11) rotate(-138.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M673.05,942.67l2.41,2.1a1.73,1.73,0,0,1,.55,2l-4.27,8.46a1.31,1.31,0,0,1-.35.42l-9.65,7.4a1.72,1.72,0,0,1-2.13-.23l-2.55-2.22a1.72,1.72,0,0,1-.5-2.11l6.24-10.35a1.16,1.16,0,0,1,.36-.37l7.81-5.39A1.74,1.74,0,0,1,673.05,942.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1136.58,233.92h-.17A17.52,17.52,0,0,0,1119,250.31q-1,15.82-1.67,31.66a16.91,16.91,0,0,0,17,17.59h.18c178.2,0,322.66,144.45,322.66,322.65s-144.6,322.66-322.66,322.66S811.8,800.41,811.8,622.22a321.18,321.18,0,0,1,58.75-185.68c-18.29-11.05-36.2-22.84-55-33.2a387.09,387.09,0,0,0-67.77,222.6c1.74,215.56,177.29,387.78,392.85,385.58,212.87-2.17,384.76-175.4,384.76-388.79C1525.39,408,1351.31,233.92,1136.58,233.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M760.72,401.26C787.13,390.48,867.5,361.2,882.9,355.6a2,2,0,0,1,2.7,1.8l6.9,136.9a17.9,17.9,0,0,1-6.69,14.88l-31.22,25a2,2,0,0,1-3.22-1.09l-24-96.67a2,2,0,0,0-2.78-1.36l-73.65,32.8a7.44,7.44,0,0,1-10.08-9.15l18.72-56.19A2,2,0,0,1,760.72,401.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1137.2,997.64A374.89,374.89,0,0,1,937,940a1.5,1.5,0,0,1,1.6-2.54,372.64,372.64,0,0,0,465.88-55.59,1.5,1.5,0,0,1,2.15,2.1A374.92,374.92,0,0,1,1137.2,997.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1426.26,861.25a1.49,1.49,0,0,1-1.15-2.45,376,376,0,0,0,32.58-46.24,1.5,1.5,0,0,1,2.58,1.54,377.58,377.58,0,0,1-32.85,46.6A1.5,1.5,0,0,1,1426.26,861.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1465.73,803.05a1.46,1.46,0,0,1-.72-.19,1.49,1.49,0,0,1-.59-2,375.36,375.36,0,0,0,19.46-41.3,1.5,1.5,0,0,1,2.79,1.1,377.12,377.12,0,0,1-19.62,41.64A1.51,1.51,0,0,1,1465.73,803.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M764.7,408.22a1.5,1.5,0,0,1-.51-2.91l106.92-39.09a1.5,1.5,0,1,1,1,2.82L765.22,408.13A1.58,1.58,0,0,1,764.7,408.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M847.22,725.55a3.26,3.26,0,0,1-3.12-2.34c-.49-1.7-1-3.4-1.42-5.11a3.26,3.26,0,0,1,6.3-1.65q.64,2.47,1.37,4.92a3.25,3.25,0,0,1-2.21,4A3.21,3.21,0,0,1,847.22,725.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M842.25,703.64a3.25,3.25,0,0,1-3.2-2.73c-.58-3.55-1.06-7.16-1.42-10.73a3.26,3.26,0,0,1,6.48-.66c.35,3.45.81,6.93,1.36,10.35a3.25,3.25,0,0,1-2.69,3.73A3.15,3.15,0,0,1,842.25,703.64Zm-2.31-27.77a3.25,3.25,0,0,1-3.25-3.24v-1.17c0-3.19.09-6.43.25-9.64a3.25,3.25,0,0,1,6.5.33c-.16,3.11-.24,6.23-.24,9.31v1.13a3.25,3.25,0,0,1-3.23,3.28Zm1.94-27.8a3.89,3.89,0,0,1-.47,0,3.25,3.25,0,0,1-2.75-3.69c.52-3.56,1.15-7.14,1.88-10.65a3.25,3.25,0,1,1,6.37,1.32c-.7,3.38-1.31,6.84-1.81,10.27A3.27,3.27,0,0,1,841.88,648.07ZM848,620.89a3.27,3.27,0,0,1-3.11-4.22c1.06-3.42,2.24-6.87,3.5-10.23a3.25,3.25,0,1,1,6.09,2.28c-1.21,3.25-2.35,6.57-3.37,9.87A3.26,3.26,0,0,1,848,620.89ZM858.29,595a3.32,3.32,0,0,1-1.43-.33,3.25,3.25,0,0,1-1.5-4.35c1.58-3.23,3.28-6.46,5-9.59a3.26,3.26,0,0,1,5.67,3.2c-1.71,3-3.35,6.13-4.87,9.24A3.24,3.24,0,0,1,858.29,595Zm14.14-24a3.25,3.25,0,0,1-2.66-5.12c2.06-3,4.23-5.87,6.45-8.68a3.25,3.25,0,0,1,5.11,4c-2.14,2.71-4.24,5.53-6.22,8.38A3.26,3.26,0,0,1,872.43,571Zm17.67-21.56a3.22,3.22,0,0,1-2.25-.91,3.25,3.25,0,0,1-.1-4.6c2.48-2.6,5.08-5.15,7.7-7.59a3.25,3.25,0,1,1,4.43,4.76c-2.53,2.36-5,4.82-7.43,7.33A3.22,3.22,0,0,1,890.1,549.39Zm20.75-18.62a3.25,3.25,0,0,1-2-5.83c2.85-2.19,5.8-4.32,8.76-6.33a3.25,3.25,0,0,1,3.66,5.38c-2.86,2-5.71,4-8.46,6.11A3.26,3.26,0,0,1,910.85,530.77Zm23.34-15.22a3.25,3.25,0,0,1-1.56-6.11c3.14-1.72,6.38-3.38,9.62-4.91a3.25,3.25,0,0,1,2.79,5.88c-3.13,1.48-6.25,3.08-9.29,4.74A3.23,3.23,0,0,1,934.19,515.55ZM1105.11,514a3.27,3.27,0,0,1-1.51-.37c-3.07-1.61-6.22-3.14-9.38-4.57a3.25,3.25,0,1,1,2.67-5.93c3.28,1.48,6.55,3.07,9.73,4.73a3.26,3.26,0,0,1-1.51,6.14Zm-145.53-9.88a3.25,3.25,0,0,1-1.11-6.31c3.37-1.22,6.82-2.36,10.26-3.37a3.25,3.25,0,0,1,1.85,6.24c-3.31,1-6.64,2.07-9.9,3.25A3.27,3.27,0,0,1,959.58,504.08Zm119.91-1.1a3.49,3.49,0,0,1-1-.17c-3.28-1.12-6.64-2.15-10-3.07a3.25,3.25,0,1,1,1.73-6.27c3.46.95,6.94,2,10.34,3.17a3.26,3.26,0,0,1-1,6.34Zm-93.07-6.31a3.25,3.25,0,0,1-.62-6.45c3.53-.69,7.12-1.28,10.67-1.75a3.25,3.25,0,1,1,.86,6.45c-3.42.46-6.89,1-10.29,1.69A3.34,3.34,0,0,1,986.42,496.67Zm66.06-.59a2.71,2.71,0,0,1-.56-.05c-3.41-.59-6.89-1.09-10.33-1.49a3.25,3.25,0,1,1,.74-6.46c3.57.41,7.17.93,10.71,1.54a3.25,3.25,0,0,1-.56,6.46Zm-38.38-2.6a3.25,3.25,0,0,1-.12-6.5c3.57-.14,7.2-.17,10.81-.1a3.26,3.26,0,0,1-.13,6.51c-3.49-.07-7,0-10.44.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1124.42,525.68a3.23,3.23,0,0,1-1.86-.59q-2.08-1.46-4.23-2.85a3.25,3.25,0,1,1,3.56-5.45c1.48,1,2.94,2,4.39,3a3.26,3.26,0,0,1-1.86,5.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1199.63,643.49a3.25,3.25,0,0,1-3.2-2.7c-.29-1.68-.61-3.35-1-5a3.25,3.25,0,0,1,6.38-1.29c.35,1.72.68,3.46,1,5.2a3.26,3.26,0,0,1-2.65,3.77A3.52,3.52,0,0,1,1199.63,643.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1017.92,855.66h-.06c-3.15,0-6.34-.19-9.48-.41l-1.16-.09a3.25,3.25,0,1,1,.49-6.48l1.12.08c3,.21,6.11.34,9.15.4a3.25,3.25,0,0,1-.06,6.5Zm17-.47a3.25,3.25,0,0,1-.24-6.5c3.4-.26,6.83-.62,10.21-1.07a3.25,3.25,0,0,1,.86,6.45c-3.5.47-7.06.84-10.58,1.11Zm-44.29-2.07a3.41,3.41,0,0,1-.55,0c-3.5-.59-7-1.29-10.45-2.08a3.26,3.26,0,0,1,1.46-6.35c3.32.76,6.71,1.44,10.08,2a3.26,3.26,0,0,1-.54,6.47Zm71.4-2.06a3.26,3.26,0,0,1-.73-6.43c3.32-.76,6.66-1.64,9.93-2.6a3.26,3.26,0,0,1,1.83,6.25c-3.39,1-6.85,1.9-10.29,2.7A3.81,3.81,0,0,1,1062,851.06Zm-98-4.57a3.29,3.29,0,0,1-1-.16c-3.36-1.12-6.73-2.34-10-3.65a3.25,3.25,0,0,1,2.4-6c3.17,1.26,6.42,2.45,9.65,3.52a3.25,3.25,0,0,1-1,6.34Zm124.2-3.63a3.26,3.26,0,0,1-1.2-6.28c3.15-1.26,6.32-2.63,9.41-4.07a3.25,3.25,0,1,1,2.75,5.89c-3.19,1.5-6.48,2.92-9.75,4.23A3.46,3.46,0,0,1,1088.18,842.86Zm-149.51-7a3.33,3.33,0,0,1-1.48-.36c-3.14-1.61-6.28-3.33-9.33-5.12a3.25,3.25,0,0,1,3.29-5.61c2.94,1.72,6,3.38,9,4.94a3.25,3.25,0,0,1-1.49,6.15Zm174.13-5.11a3.25,3.25,0,0,1-1.65-6.06c2.94-1.73,5.86-3.56,8.69-5.45a3.25,3.25,0,0,1,3.62,5.41c-2.93,2-6,3.86-9,5.65A3.15,3.15,0,0,1,1112.8,830.79Zm22.52-15.64a3.25,3.25,0,0,1-2-5.78c2.64-2.15,5.26-4.4,7.78-6.7a3.25,3.25,0,1,1,4.38,4.81c-2.6,2.38-5.32,4.71-8.06,6.94A3.24,3.24,0,0,1,1135.32,815.15Zm19.92-18.85a3.24,3.24,0,0,1-2.4-5.44c2.29-2.52,4.54-5.14,6.69-7.8a3.26,3.26,0,0,1,5.06,4.1c-2.23,2.75-4.56,5.47-6.94,8.08A3.25,3.25,0,0,1,1155.24,796.3Zm16.87-21.63a3.29,3.29,0,0,1-1.8-.54,3.26,3.26,0,0,1-.91-4.51c1.89-2.84,3.72-5.78,5.44-8.73a3.26,3.26,0,1,1,5.62,3.29c-1.79,3.05-3.68,6.09-5.64,9A3.26,3.26,0,0,1,1172.11,774.67Zm13.4-23.94a3.31,3.31,0,0,1-1.36-.3,3.26,3.26,0,0,1-1.59-4.32c1.44-3.1,2.8-6.28,4.06-9.45a3.25,3.25,0,1,1,6.05,2.39c-1.3,3.29-2.71,6.59-4.2,9.8A3.27,3.27,0,0,1,1185.51,750.73Zm9.62-25.7a3.26,3.26,0,0,1-3.13-4.16c1-3.27,1.81-6.62,2.57-9.94a3.25,3.25,0,0,1,6.34,1.44c-.78,3.45-1.68,6.91-2.66,10.31A3.25,3.25,0,0,1,1195.13,725Zm5.6-26.85a3.17,3.17,0,0,1-.43,0,3.25,3.25,0,0,1-2.8-3.65c.44-3.38.79-6.82,1-10.22a3.25,3.25,0,1,1,6.49.48c-.26,3.52-.62,7.08-1.08,10.58A3.25,3.25,0,0,1,1200.73,698.18Zm1.51-27.38a3.25,3.25,0,0,1-3.25-3.19c-.07-3.41-.23-6.86-.5-10.26a3.25,3.25,0,1,1,6.49-.5c.27,3.52.45,7.1.52,10.63a3.27,3.27,0,0,1-3.2,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M915.18,821.53a3.27,3.27,0,0,1-1.9-.62q-2.14-1.56-4.25-3.16a3.26,3.26,0,0,1,4-5.17q2,1.56,4.1,3a3.26,3.26,0,0,1-1.91,5.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M923.28,770.26a2.16,2.16,0,0,0,2.43.66l24.84-9.13a115.27,115.27,0,0,0,32.88,17.71l6.06,25.74a2.17,2.17,0,0,0,1.9,1.67l31.58,3.2a2.16,2.16,0,0,0,2.19-1.25l11.1-24A115.44,115.44,0,0,0,1072,774.1l22.5,13.93a2.18,2.18,0,0,0,2.52-.17l24.59-20.07a2.17,2.17,0,0,0,.67-2.43l-9.13-24.84a115.44,115.44,0,0,0,17.71-32.89l25.74-6a2.18,2.18,0,0,0,1.66-1.9l3.2-31.58a2.16,2.16,0,0,0-1.25-2.2l-24-11.09A115.11,115.11,0,0,0,1125.48,619l13.93-22.5a2.18,2.18,0,0,0-.16-2.52l-20.07-24.59a2.18,2.18,0,0,0-2.44-.67l-24.84,9.13A115.39,115.39,0,0,0,1059,560.18L1053,534.44a2.18,2.18,0,0,0-1.89-1.67l-31.59-3.19a2.15,2.15,0,0,0-2.19,1.25l-11.1,24a115.13,115.13,0,0,0-35.76,10.76l-22.51-13.93a2.18,2.18,0,0,0-2.52.16l-24.59,20.07a2.18,2.18,0,0,0-.67,2.44l9.14,24.83a115.33,115.33,0,0,0-17.71,32.89l-25.74,6.06a2.16,2.16,0,0,0-1.67,1.89L881,671.59a2.18,2.18,0,0,0,1.25,2.19l24,11.1A115.38,115.38,0,0,0,917,720.64L903,743.15a2.17,2.17,0,0,0,.17,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1021.16,700.64a30.86,30.86,0,1,1,4.56-.34A30.57,30.57,0,0,1,1021.16,700.64Zm.08-56.38a26.45,26.45,0,0,0-3.74.27,25.61,25.61,0,1,0,3.74-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1021.77,747.28c-2.61,0-5.25-.14-7.91-.4a79.09,79.09,0,0,1-11.66-2.08l-.09,0-.5-.13-.07,0h-.07l-.24-.07h0l-.1,0h0l-.73-.2-.25-.08-1.57-.46-.89-.29a1.31,1.31,0,0,1-.9-1.24,1.44,1.44,0,0,1,.06-.4,1.3,1.3,0,0,1,1.64-.83,75.83,75.83,0,0,0,15.7,3.28A75.27,75.27,0,0,0,1096.62,677a76.16,76.16,0,0,0,.39-7.66,75.3,75.3,0,1,0-143.49,32,1.17,1.17,0,0,1,.13.55,1.3,1.3,0,0,1-2.48.55,77.65,77.65,0,0,1-7.36-33c0-2.64.14-5.27.4-7.91a77.9,77.9,0,0,1,155.41,7.78,78.05,78.05,0,0,1-77.85,78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1208.64,512.55l13.47-6.21a64.35,64.35,0,0,0,19.15,8.43l4.53,14.11a1.2,1.2,0,0,0,1.13.85l17.78.38a1.23,1.23,0,0,0,1.17-.79l5.13-13.91a64.53,64.53,0,0,0,19.5-7.59l13.19,6.78a1.21,1.21,0,0,0,1.4-.2l12.84-12.31a1.22,1.22,0,0,0,.27-1.39L1312,487.24a64.41,64.41,0,0,0,8.43-19.16l14.11-4.52a1.22,1.22,0,0,0,.85-1.14l.38-17.78a1.23,1.23,0,0,0-.79-1.17l-13.9-5.13a64.81,64.81,0,0,0-7.6-19.5l6.78-13.18a1.21,1.21,0,0,0-.2-1.4l-12.3-12.85a1.22,1.22,0,0,0-1.39-.26l-13.47,6.2a64.61,64.61,0,0,0-19.15-8.43l-4.53-14.11a1.21,1.21,0,0,0-1.13-.84l-17.79-.39a1.22,1.22,0,0,0-1.16.8l-5.14,13.9a64.63,64.63,0,0,0-19.5,7.59l-13.18-6.78a1.21,1.21,0,0,0-1.4.21l-12.85,12.3a1.22,1.22,0,0,0-.26,1.39l6.2,13.46a65,65,0,0,0-8.43,19.16l-14.11,4.52a1.23,1.23,0,0,0-.84,1.14l-.39,17.78a1.22,1.22,0,0,0,.8,1.17l13.9,5.13a64.53,64.53,0,0,0,7.59,19.5L1194.74,498a1.23,1.23,0,0,0,.21,1.4l12.3,12.84A1.23,1.23,0,0,0,1208.64,512.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1257.46,469a17.13,17.13,0,1,1,3.86-.44A17.45,17.45,0,0,1,1257.46,469Zm0-31.6a14.49,14.49,0,1,0,14.12,11.25A14.38,14.38,0,0,0,1257.5,437.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1177.73,507.38a3.24,3.24,0,0,1-2.72-1.47c-1-1.49-1.93-3-2.83-4.58a3.26,3.26,0,0,1,5.63-3.27c.84,1.45,1.73,2.89,2.64,4.28a3.24,3.24,0,0,1-.94,4.5A3.21,3.21,0,0,1,1177.73,507.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1168.14,488.38a3.25,3.25,0,0,1-3.05-2.12,99,99,0,0,1-3.06-9.78,3.25,3.25,0,1,1,6.3-1.63,92.42,92.42,0,0,0,2.86,9.15,3.26,3.26,0,0,1-1.92,4.18A3.21,3.21,0,0,1,1168.14,488.38Zm-5.67-25.33a3.26,3.26,0,0,1-3.24-3c-.23-2.75-.35-5.54-.35-8.31,0-.65,0-1.29,0-1.94a3.21,3.21,0,0,1,3.32-3.19,3.24,3.24,0,0,1,3.18,3.32c0,.6,0,1.21,0,1.81,0,2.58.11,5.19.33,7.76a3.27,3.27,0,0,1-3,3.52Zm1.37-25.92a3.34,3.34,0,0,1-.62-.06,3.25,3.25,0,0,1-2.58-3.81,100.33,100.33,0,0,1,2.46-9.95,3.26,3.26,0,1,1,6.23,1.89,92.62,92.62,0,0,0-2.3,9.29A3.25,3.25,0,0,1,1163.84,437.13Zm8.33-24.58a3.25,3.25,0,0,1-2.91-4.71,99.14,99.14,0,0,1,5-8.92,3.25,3.25,0,1,1,5.49,3.49,92.49,92.49,0,0,0-4.72,8.34A3.25,3.25,0,0,1,1172.17,412.55Zm14.63-21.44a3.2,3.2,0,0,1-2.18-.84,3.25,3.25,0,0,1-.23-4.59,99,99,0,0,1,7.25-7.24,3.25,3.25,0,1,1,4.35,4.84,91.86,91.86,0,0,0-6.77,6.76A3.25,3.25,0,0,1,1186.8,391.11Zm19.86-16.7a3.26,3.26,0,0,1-1.74-6,99.33,99.33,0,0,1,9-5,3.25,3.25,0,0,1,2.87,5.84,88.71,88.71,0,0,0-8.36,4.67A3.19,3.19,0,0,1,1206.66,374.41Zm23.64-10.7a3.25,3.25,0,0,1-.92-6.37c2-.59,4-1.13,6.06-1.59,1.3-.3,2.6-.57,3.9-.82a3.26,3.26,0,0,1,1.2,6.4c-1.21.23-2.43.48-3.65.76-1.9.44-3.8.94-5.66,1.49A3.31,3.31,0,0,1,1230.3,363.71Zm35.57-3.61-.29,0a95.53,95.53,0,0,0-9.57-.33,3.26,3.26,0,0,1-.11-6.51,97.43,97.43,0,0,1,10.25.36,3.26,3.26,0,0,1-.28,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1286.77,364.35a3.17,3.17,0,0,1-1-.16c-1.59-.52-3.21-1-4.82-1.42a3.25,3.25,0,1,1,1.66-6.29c1.73.46,3.46,1,5.16,1.52a3.25,3.25,0,0,1-1,6.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1343.74,414.4a3.24,3.24,0,0,1-2.94-1.87q-1.08-2.28-2.27-4.49a3.26,3.26,0,0,1,5.73-3.09c.84,1.57,1.66,3.18,2.42,4.81a3.25,3.25,0,0,1-2.94,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1257.45,550.47a98.42,98.42,0,0,1-11.28-.65,3.26,3.26,0,1,1,.75-6.47,92,92,0,0,0,10.49.61h.15a3.26,3.26,0,0,1,0,6.51h-.11Zm17.93-1.72a3.25,3.25,0,0,1-.61-6.45c1.11-.21,2.22-.44,3.33-.7,2.36-.54,4.72-1.18,7-1.9a3.26,3.26,0,0,1,2,6.22c-2.46.76-5,1.45-7.5,2-1.19.28-2.38.53-3.56.75A3.26,3.26,0,0,1,1275.38,548.75Zm27.22-9.62a3.25,3.25,0,0,1-1.54-6.12,90.85,90.85,0,0,0,9.08-5.57,3.25,3.25,0,0,1,3.72,5.34,99,99,0,0,1-9.73,6A3.24,3.24,0,0,1,1302.6,539.13Zm23.06-17.34a3.26,3.26,0,0,1-2.33-5.53,92.33,92.33,0,0,0,7-8,3.26,3.26,0,0,1,5.15,4,100.26,100.26,0,0,1-7.49,8.6A3.23,3.23,0,0,1,1325.66,521.79Zm16.81-23.45a3.25,3.25,0,0,1-2.89-4.73,91,91,0,0,0,4.28-9.76,3.25,3.25,0,1,1,6.1,2.27,98.86,98.86,0,0,1-4.58,10.44A3.26,3.26,0,0,1,1342.47,498.34Zm9.08-27.4a3.41,3.41,0,0,1-.55-.05,3.25,3.25,0,0,1-2.66-3.75,91.66,91.66,0,0,0,1.15-10.59,3.25,3.25,0,1,1,6.5.33,98.21,98.21,0,0,1-1.24,11.35A3.26,3.26,0,0,1,1351.55,470.94Zm.4-28.87a3.26,3.26,0,0,1-3.22-2.8c-.37-2.68-.87-5.38-1.48-8-.18-.82-.38-1.63-.59-2.43a3.25,3.25,0,0,1,6.3-1.63c.23.87.44,1.73.64,2.61.65,2.83,1.18,5.72,1.58,8.58a3.26,3.26,0,0,1-2.78,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1229,546.09a3.07,3.07,0,0,1-1-.15c-1.7-.53-3.41-1.12-5.08-1.75a3.25,3.25,0,0,1,2.29-6.09c1.56.58,3.16,1.13,4.75,1.64a3.25,3.25,0,0,1-1,6.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1257.52,496.06h-1a44.81,44.81,0,0,1-9.33-1.19,1.29,1.29,0,0,1-1-1.27,1.53,1.53,0,0,1,0-.3,1.31,1.31,0,0,1,1.57-1,41.73,41.73,0,0,0,8.79,1.12,41.61,41.61,0,0,0,42.5-40.7c0-.31,0-.61,0-.91a41.61,41.61,0,0,0-83.22-.89c0,.3,0,.6,0,.9a41.57,41.57,0,0,0,5.45,20.59,1.33,1.33,0,0,1,.17.64,1.31,1.31,0,0,1-.66,1.13,1.29,1.29,0,0,1-1.77-.48,44.08,44.08,0,0,1-5.79-21.88c0-.32,0-.64,0-1a44.22,44.22,0,0,1,88.43.95c0,.32,0,.64,0,1a44.22,44.22,0,0,1-44.19,43.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1212.87,704.69a3.25,3.25,0,0,1-3.12-2.34c-.5-1.69-1-3.43-1.39-5.15a3.25,3.25,0,1,1,6.31-1.57c.41,1.64.85,3.28,1.32,4.89a3.25,3.25,0,0,1-2.2,4A3.3,3.3,0,0,1,1212.87,704.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1208.63,683.13a3.25,3.25,0,0,1-3.23-2.93c-.36-3.49-.58-7.06-.64-10.59a3.26,3.26,0,0,1,6.51-.12c0,3.35.26,6.73.6,10a3.26,3.26,0,0,1-2.9,3.57Zm.24-27.09-.39,0a3.27,3.27,0,0,1-2.85-3.62c.42-3.51,1-7,1.71-10.47a3.25,3.25,0,1,1,6.37,1.31c-.67,3.27-1.22,6.61-1.61,9.93A3.27,3.27,0,0,1,1208.87,656Zm6.19-26.36a3.28,3.28,0,0,1-3.07-4.35c1.19-3.33,2.54-6.64,4-9.84a3.26,3.26,0,0,1,5.92,2.71c-1.39,3-2.66,6.16-3.79,9.32A3.25,3.25,0,0,1,1215.06,629.68ZM1227,605.35a3.25,3.25,0,0,1-2.74-5c1.9-3,4-5.89,6.09-8.69a3.26,3.26,0,1,1,5.17,4c-2,2.65-4,5.42-5.77,8.24A3.28,3.28,0,0,1,1227,605.35Zm17-21.06a3.2,3.2,0,0,1-2.31-1,3.24,3.24,0,0,1,0-4.6c2.51-2.48,5.15-4.87,7.86-7.13a3.26,3.26,0,1,1,4.17,5c-2.57,2.14-5.08,4.41-7.45,6.76A3.24,3.24,0,0,1,1244,584.29Zm21.27-16.78a3.25,3.25,0,0,1-1.73-6c3-1.87,6.11-3.62,9.24-5.22a3.26,3.26,0,0,1,3,5.8c-3,1.51-5.92,3.18-8.76,4.94A3.16,3.16,0,0,1,1265.29,567.51Zm113.94-7.5a3.21,3.21,0,0,1-1.34-.29c-3-1.38-6.18-2.64-9.33-3.75a3.25,3.25,0,1,1,2.16-6.14c3.33,1.18,6.64,2.51,9.85,4a3.25,3.25,0,0,1-1.34,6.22Zm-89.51-4.14a3.26,3.26,0,0,1-1.06-6.33c3.34-1.15,6.76-2.17,10.17-3a3.25,3.25,0,1,1,1.59,6.31c-3.24.81-6.48,1.78-9.64,2.87A3.28,3.28,0,0,1,1289.72,555.87Zm63.73-4.18a3.66,3.66,0,0,1-.65-.06c-3.27-.66-6.61-1.19-9.94-1.57a3.26,3.26,0,0,1,.75-6.47c3.5.4,7,1,10.48,1.66a3.25,3.25,0,0,1-.64,6.44ZM1316.14,550a3.25,3.25,0,0,1-.34-6.49c3.49-.37,7.06-.6,10.59-.68h.07a3.26,3.26,0,0,1,.07,6.51c-3.35.07-6.72.29-10,.64A2.17,2.17,0,0,1,1316.14,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1398.42,570.9a3.29,3.29,0,0,1-1.86-.58c-1.37-1-2.79-1.9-4.21-2.8a3.25,3.25,0,0,1,3.48-5.5c1.5,1,3,2,4.45,3a3.25,3.25,0,0,1-1.86,5.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1449,651.47a3.27,3.27,0,0,1-3.21-2.75c-.26-1.67-.56-3.35-.9-5a3.26,3.26,0,0,1,6.38-1.3c.35,1.73.67,3.5,1,5.26a3.26,3.26,0,0,1-2.7,3.73A4.73,4.73,0,0,1,1449,651.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1329.42,791.81c-1.38,0-2.82,0-4.23-.07a3.26,3.26,0,0,1,.1-6.51h.11q2,.06,4,.06h0c1.95,0,3.93,0,5.88-.14a3.25,3.25,0,0,1,.33,6.5C1333.57,791.76,1331.48,791.81,1329.42,791.81Zm-20.56-1.73a3.39,3.39,0,0,1-.55,0c-3.43-.58-6.86-1.31-10.22-2.18a3.25,3.25,0,0,1,1.62-6.3c3.18.82,6.44,1.51,9.69,2.06a3.25,3.25,0,0,1-.54,6.46Zm43-.37a3.25,3.25,0,0,1-.6-6.45c3.23-.61,6.47-1.37,9.64-2.25a3.25,3.25,0,0,1,1.74,6.27c-3.34.93-6.76,1.73-10.17,2.37A3.15,3.15,0,0,1,1351.86,789.71Zm-68.64-7a3.32,3.32,0,0,1-1.23-.24c-3.21-1.32-6.41-2.79-9.49-4.37a3.25,3.25,0,1,1,3-5.79c2.92,1.49,5.94,2.89,9,4.14a3.25,3.25,0,0,1-1.24,6.26Zm94.11-.86a3.25,3.25,0,0,1-1.29-6.24c3-1.3,6-2.75,8.9-4.31a3.26,3.26,0,1,1,3.08,5.74c-3.06,1.64-6.22,3.17-9.4,4.54A3.11,3.11,0,0,1,1377.33,781.9Zm23.14-13.2a3.26,3.26,0,0,1-1.91-5.89c2.66-1.93,5.27-4,7.76-6.14a3.25,3.25,0,0,1,4.25,4.93c-2.63,2.26-5.38,4.44-8.19,6.48A3.2,3.2,0,0,1,1400.47,768.7Zm19.73-17.92a3.26,3.26,0,0,1-2.44-5.41c2.18-2.47,4.28-5,6.24-7.69a3.26,3.26,0,0,1,5.22,3.89c-2.07,2.78-4.29,5.51-6.58,8.11A3.25,3.25,0,0,1,1420.2,750.78ZM1435.55,729a3.18,3.18,0,0,1-1.57-.41,3.25,3.25,0,0,1-1.28-4.42c1.58-2.88,3.07-5.86,4.4-8.86a3.25,3.25,0,0,1,6,2.64c-1.41,3.18-3,6.32-4.65,9.36A3.25,3.25,0,0,1,1435.55,729Zm10.2-24.64a3.18,3.18,0,0,1-.91-.13,3.26,3.26,0,0,1-2.22-4c.91-3.15,1.7-6.39,2.35-9.61a3.25,3.25,0,0,1,6.38,1.27c-.68,3.41-1.52,6.82-2.48,10.15A3.25,3.25,0,0,1,1445.75,704.35Zm4.55-26.26h-.21a3.26,3.26,0,0,1-3-3.46c.15-2.48.23-5,.23-7.45,0-.82,0-1.63,0-2.44a3.24,3.24,0,0,1,3.18-3.32h.07a3.25,3.25,0,0,1,3.25,3.19c0,.86,0,1.71,0,2.58,0,2.6-.08,5.25-.25,7.86A3.25,3.25,0,0,1,1450.3,678.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1259.76,769.93a3.29,3.29,0,0,1-1.86-.58c-1.46-1-2.91-2.09-4.31-3.16a3.26,3.26,0,0,1,4-5.17c1.33,1,2.7,2,4.08,3a3.25,3.25,0,0,1-1.87,5.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1263.78,733.55a1.45,1.45,0,0,0,1.63.44l16.63-6.11a77.37,77.37,0,0,0,22,11.85l4,17.23a1.46,1.46,0,0,0,1.27,1.12l21.14,2.14a1.45,1.45,0,0,0,1.47-.84l7.43-16.07a77,77,0,0,0,23.94-7.2l15.06,9.33a1.48,1.48,0,0,0,1.69-.11l16.46-13.44a1.46,1.46,0,0,0,.45-1.63l-6.12-16.62a77.28,77.28,0,0,0,11.86-22l17.23-4.06a1.45,1.45,0,0,0,1.11-1.27l2.15-21.14a1.47,1.47,0,0,0-.84-1.47l-16.07-7.43a77.35,77.35,0,0,0-7.2-23.94l9.32-15.06a1.44,1.44,0,0,0-.11-1.69l-13.43-16.46a1.45,1.45,0,0,0-1.63-.44l-16.63,6.11a76.88,76.88,0,0,0-22-11.85l-4.05-17.24a1.45,1.45,0,0,0-1.27-1.11l-21.14-2.14a1.45,1.45,0,0,0-1.47.83l-7.43,16.07a77.27,77.27,0,0,0-23.94,7.2l-15.06-9.32a1.46,1.46,0,0,0-1.69.11l-16.46,13.43a1.47,1.47,0,0,0-.45,1.63L1267.8,619a77.15,77.15,0,0,0-11.86,22l-17.23,4.06a1.45,1.45,0,0,0-1.11,1.27l-2.15,21.14a1.46,1.46,0,0,0,.84,1.46l16.07,7.43a77.27,77.27,0,0,0,7.2,23.94l-9.32,15.07a1.43,1.43,0,0,0,.11,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1329.3,689.11a22.84,22.84,0,1,1,3.37-.25A24.11,24.11,0,0,1,1329.3,689.11Zm.08-37.75a15.09,15.09,0,0,0-2.22.17,15,15,0,1,0,4.37,29.6h0a15,15,0,0,0-2.15-29.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1329.71,718.59c-1.77,0-3.54-.09-5.34-.27h0a52.66,52.66,0,0,1-10.95-2.3,1.28,1.28,0,0,1-.9-1.23,1.34,1.34,0,0,1,.06-.4,1.3,1.3,0,0,1,1.64-.84,50,50,0,0,0,65.17-42.5c.17-1.71.25-3.4.25-5.08a50,50,0,0,0-99.68-5,47.82,47.82,0,0,0-.26,5.07,49.71,49.71,0,0,0,4.72,21.17,1.37,1.37,0,0,1,.12.55,1.3,1.3,0,0,1-2.48.56,52.31,52.31,0,0,1-5-22.28c0-1.78.09-3.56.26-5.33A52.58,52.58,0,0,1,1382.25,666c0,1.76-.09,3.55-.27,5.34A52.65,52.65,0,0,1,1329.71,718.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1153.86,852.73a3.25,3.25,0,0,1-3.12-2.34c-.51-1.74-1-3.53-1.33-5.3a3.25,3.25,0,0,1,6.37-1.33c.34,1.61.74,3.22,1.21,4.8a3.27,3.27,0,0,1-2.21,4A3.71,3.71,0,0,1,1153.86,852.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1151.33,831.26h-.17a3.26,3.26,0,0,1-3.09-3.42c0-.47,0-.94.09-1.41a68.1,68.1,0,0,1,1.25-9.14,3.25,3.25,0,1,1,6.37,1.31,62,62,0,0,0-1.13,8.28c0,.43-.06.86-.08,1.29A3.25,3.25,0,0,1,1151.33,831.26Zm6.6-25.63a3.2,3.2,0,0,1-1.43-.34,3.26,3.26,0,0,1-1.48-4.36,68.25,68.25,0,0,1,5.45-9.16,3.25,3.25,0,1,1,5.31,3.76,62.33,62.33,0,0,0-4.93,8.28A3.25,3.25,0,0,1,1157.93,805.63Zm16.31-20.87a3.25,3.25,0,0,1-2.1-5.73,68.85,68.85,0,0,1,8.63-6.24,3.26,3.26,0,0,1,3.39,5.56,62,62,0,0,0-7.81,5.64A3.25,3.25,0,0,1,1174.24,784.76Zm23.24-12.66a3.26,3.26,0,0,1-.94-6.37,68.54,68.54,0,0,1,10.41-2.28,3.25,3.25,0,0,1,.88,6.45,62,62,0,0,0-9.41,2.06A3.4,3.4,0,0,1,1197.48,772.1Zm36.33-.39a3.26,3.26,0,0,1-.87-.12,61.55,61.55,0,0,0-9.46-1.85,3.25,3.25,0,1,1,.74-6.46,68.09,68.09,0,0,1,10.46,2,3.25,3.25,0,0,1-.87,6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1253.43,780.93a3.22,3.22,0,0,1-1.86-.58c-1.35-.94-2.75-1.83-4.16-2.65a3.26,3.26,0,1,1,3.27-5.63c1.56.91,3.11,1.9,4.61,2.94a3.25,3.25,0,0,1-1.86,5.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1280.93,826.56a3.26,3.26,0,0,1-3.23-2.87c-.2-1.63-.46-3.27-.79-4.88a3.25,3.25,0,1,1,6.38-1.29c.36,1.77.65,3.59.87,5.39a3.25,3.25,0,0,1-2.84,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1221.53,899.27a3.25,3.25,0,0,1-.25-6.5,61.39,61.39,0,0,0,9.36-1.47,3.25,3.25,0,1,1,1.5,6.33,66.57,66.57,0,0,1-10.35,1.63Zm-16.17-.72a3.29,3.29,0,0,1-.54,0,67.82,67.82,0,0,1-10.17-2.54,3.25,3.25,0,1,1,2.06-6.17,62.83,62.83,0,0,0,9.2,2.3,3.25,3.25,0,0,1-.55,6.46Zm41.19-6.51a3.26,3.26,0,0,1-1.52-6.14,62.42,62.42,0,0,0,8-5,3.25,3.25,0,0,1,3.87,5.23,69.79,69.79,0,0,1-8.87,5.57A3.3,3.3,0,0,1,1246.55,892Zm20.17-16.47a3.25,3.25,0,0,1-2.52-5.31,61.16,61.16,0,0,0,5.42-7.78,3.26,3.26,0,0,1,5.61,3.31,68.43,68.43,0,0,1-6,8.59A3.24,3.24,0,0,1,1266.72,875.57Zm12.11-23.05a3.16,3.16,0,0,1-.9-.13,3.24,3.24,0,0,1-2.22-4,61.87,61.87,0,0,0,1.92-9.28,3.25,3.25,0,0,1,6.45.83,68.42,68.42,0,0,1-2.12,10.26A3.25,3.25,0,0,1,1278.83,852.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1181,889.08a3.17,3.17,0,0,1-1.76-.52c-1.53-1-3-2-4.47-3.15a3.25,3.25,0,0,1,4-5.16c1.3,1,2.66,2,4,2.85a3.25,3.25,0,0,1-1.77,6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1181.18,866.7a.78.78,0,0,0,.88.24l8.92-3.28a41.16,41.16,0,0,0,11.81,6.36l2.17,9.25a.8.8,0,0,0,.69.6L1217,881a.79.79,0,0,0,.79-.45l4-8.63a41.43,41.43,0,0,0,12.85-3.86l8.08,5a.77.77,0,0,0,.91-.06l8.83-7.2a.78.78,0,0,0,.24-.88l-3.28-8.92a41.29,41.29,0,0,0,6.36-11.81L1265,842a.79.79,0,0,0,.6-.68l1.15-11.34a.79.79,0,0,0-.45-.79l-8.63-4a41,41,0,0,0-3.86-12.84l5-8.09a.77.77,0,0,0,0-.9l-7.21-8.84a.81.81,0,0,0-.88-.24l-8.92,3.29a41.56,41.56,0,0,0-11.81-6.37l-2.18-9.24a.76.76,0,0,0-.68-.6l-11.34-1.15a.79.79,0,0,0-.79.45l-4,8.62a41.31,41.31,0,0,0-12.84,3.87l-8.09-5a.78.78,0,0,0-.9.06l-8.84,7.21a.78.78,0,0,0-.23.87l3.28,8.93a41.16,41.16,0,0,0-6.36,11.81l-9.25,2.17a.78.78,0,0,0-.6.69L1166,831.26a.79.79,0,0,0,.45.79l8.62,4a41.45,41.45,0,0,0,3.87,12.85l-5,8.08a.8.8,0,0,0,.06.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1216.35,844.66a14,14,0,1,1,8.38-25.29,14,14,0,0,1-6.32,25.14A14.38,14.38,0,0,1,1216.35,844.66Zm0-20.25a5.62,5.62,0,0,0-.92.07,6.14,6.14,0,1,0,.92-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1216.56,859.28a29,29,0,0,1-2.93-.15c-.62-.06-1.24-.14-1.86-.25h0a29.27,29.27,0,0,1-3-.66h0l-.09,0-.57-.17-.46-.15a1.28,1.28,0,0,1-.9-1.23,1.45,1.45,0,0,1,.06-.41,1.3,1.3,0,0,1,1.64-.83,26.73,26.73,0,0,0,5.47,1.14h0a26.23,26.23,0,0,0,28.67-23c0-.14,0-.28,0-.41.09-.91.13-1.8.13-2.7a26.21,26.21,0,0,0-52.29-2.59,26.46,26.46,0,0,0-.13,2.66,26.18,26.18,0,0,0,2.47,11.11,1.37,1.37,0,0,1,.12.55,1.29,1.29,0,0,1-.75,1.18,1.31,1.31,0,0,1-1.73-.63,28.82,28.82,0,1,1,54.92-12.28,29.49,29.49,0,0,1-.15,3A28.87,28.87,0,0,1,1216.56,859.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1073.18,429.4a1,1,0,0,1-.62-.21c-.66-.52-1.32-1.06-2-1.61a1,1,0,0,1,1.3-1.52c.62.53,1.26,1.05,1.9,1.56a1,1,0,0,1-.62,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1067.49,424.36a1,1,0,0,1-.7-.29c-1.22-1.21-2.41-2.49-3.53-3.79a1,1,0,0,1,1.52-1.31c1.08,1.27,2.24,2.51,3.42,3.68a1,1,0,0,1-.71,1.71Zm-6.65-7.73a1,1,0,0,1-.8-.41c-1-1.39-2-2.83-2.91-4.29a1,1,0,1,1,1.7-1.06c.88,1.42,1.83,2.82,2.82,4.17a1,1,0,0,1-.22,1.39A.94.94,0,0,1,1060.84,416.63Zm-5.39-8.66a1,1,0,0,1-.89-.54c-.8-1.53-1.55-3.1-2.22-4.68a1,1,0,0,1,.52-1.31,1,1,0,0,1,1.32.52c.65,1.53,1.38,3.06,2.15,4.55a1,1,0,0,1-.42,1.35A1.11,1.11,0,0,1,1055.45,408Zm-4-9.38a1,1,0,0,1-1-.68c-.55-1.63-1-3.3-1.47-5a1,1,0,0,1,1.94-.49c.41,1.62.89,3.24,1.43,4.82a1,1,0,0,1-.63,1.27A1.13,1.13,0,0,1,1051.43,398.59Zm-2.52-9.89a1,1,0,0,1-1-.82c-.29-1.7-.52-3.43-.68-5.14a1,1,0,1,1,2-.19c.15,1.66.38,3.34.67,5a1,1,0,0,1-.82,1.16Zm-1-10.15a1,1,0,0,1-1-1c0-.4,0-.79,0-1.18,0-1.32,0-2.67.12-4a1,1,0,0,1,1-.93,1,1,0,0,1,.94,1.05c-.08,1.3-.11,2.61-.11,3.89,0,.38,0,.76,0,1.14a1,1,0,0,1-1,1Zm.61-10.19h-.13a1,1,0,0,1-.86-1.12c.23-1.7.54-3.42.9-5.1a1,1,0,1,1,2,.42c-.36,1.63-.65,3.3-.88,4.95A1,1,0,0,1,1048.55,368.36Zm2.16-10a1,1,0,0,1-.29,0,1,1,0,0,1-.67-1.24c.49-1.65,1-3.3,1.67-4.91a1,1,0,0,1,1.86.72c-.59,1.56-1.14,3.16-1.61,4.76A1,1,0,0,1,1050.71,358.39Zm3.65-9.52a.94.94,0,0,1-.43-.1,1,1,0,0,1-.48-1.33c.74-1.56,1.55-3.1,2.4-4.59a1,1,0,0,1,1.74,1c-.83,1.45-1.61,3-2.33,4.46A1,1,0,0,1,1054.36,348.87Zm5.06-8.85a1,1,0,0,1-.56-.17,1,1,0,0,1-.27-1.39c1-1.43,2-2.83,3.08-4.17a1,1,0,1,1,1.56,1.25c-1,1.3-2,2.66-3,4A1,1,0,0,1,1059.42,340Zm6.37-8a1,1,0,0,1-.68-.27,1,1,0,0,1,0-1.42c1.17-1.25,2.41-2.48,3.68-3.64a1,1,0,1,1,1.35,1.47c-1.23,1.13-2.43,2.32-3.57,3.54A1,1,0,0,1,1065.79,332.06Zm7.52-6.89a1,1,0,0,1-.61-1.79c1.35-1.06,2.76-2.08,4.19-3A1,1,0,1,1,1078,322c-1.39.93-2.76,1.92-4.07,2.95A1,1,0,0,1,1073.31,325.17Zm8.49-5.66a1,1,0,0,1-.87-.51,1,1,0,0,1,.38-1.36c1.5-.84,3.06-1.64,4.61-2.36a1,1,0,1,1,.85,1.81c-1.51.7-3,1.47-4.48,2.29A1,1,0,0,1,1081.8,319.51Zm9.25-4.3a1,1,0,0,1-.35-1.94c1.61-.6,3.27-1.15,4.92-1.63a1,1,0,0,1,.56,1.93c-1.61.46-3.21,1-4.78,1.58A1,1,0,0,1,1091.05,315.21Zm9.8-2.83a1,1,0,0,1-1-.8,1,1,0,0,1,.77-1.18c1.69-.35,3.41-.63,5.12-.85a1,1,0,0,1,.25,2c-1.66.21-3.33.48-5,.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1111,311.1a1,1,0,0,1,0-2c.84,0,1.69-.06,2.53-.07a1,1,0,0,1,1,1,1,1,0,0,1-1,1c-.82,0-1.64,0-2.46.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1161.35,330.66a1,1,0,0,1-.71-.3c-.58-.58-1.17-1.16-1.76-1.71a1,1,0,1,1,1.36-1.46c.62.57,1.22,1.16,1.82,1.77a1,1,0,0,1,0,1.41A1,1,0,0,1,1161.35,330.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1119.45,443.44a1,1,0,0,1-1-.92,1,1,0,0,1,.92-1.08c1.64-.13,3.29-.32,4.92-.57a1,1,0,0,1,.3,2c-1.67.26-3.37.45-5.06.59Zm9.92-1.54a1,1,0,0,1-.23-2c1.6-.38,3.21-.82,4.77-1.32a1,1,0,1,1,.61,1.91c-1.62.51-3.27,1-4.92,1.35Zm9.57-3a1,1,0,0,1-.37-1.93c1.53-.61,3-1.29,4.51-2a1,1,0,1,1,.89,1.79c-1.51.75-3.08,1.45-4.65,2.09A1,1,0,0,1,1138.94,438.87Zm9-4.45a1,1,0,0,1-.51-1.86l.85-.51c1.13-.69,2.24-1.41,3.31-2.16a1,1,0,0,1,1.14,1.64c-1.1.77-2.25,1.52-3.4,2.22l-.89.54A1,1,0,0,1,1148,434.42Zm8.24-5.73a1,1,0,0,1-.78-.37,1,1,0,0,1,.14-1.41c1.28-1,2.53-2.14,3.72-3.26a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.42c-1.22,1.16-2.51,2.29-3.82,3.36A1,1,0,0,1,1156.19,428.69Zm7.27-6.91a1,1,0,0,1-.67-.26,1,1,0,0,1-.07-1.41c1.1-1.22,2.17-2.5,3.17-3.8a1,1,0,1,1,1.58,1.23c-1,1.33-2.13,2.65-3.27,3.91A1,1,0,0,1,1163.46,421.78Zm6.14-7.94a1,1,0,0,1-.83-1.55c.9-1.37,1.76-2.79,2.56-4.23a1,1,0,0,1,1.36-.39,1,1,0,0,1,.39,1.36c-.82,1.48-1.71,3-2.64,4.36A1,1,0,0,1,1169.6,413.84Zm4.87-8.77a1.06,1.06,0,0,1-.42-.09,1,1,0,0,1-.49-1.33c.69-1.49,1.32-3,1.89-4.57a1,1,0,1,1,1.88.7c-.59,1.58-1.25,3.17-1.95,4.7A1,1,0,0,1,1174.47,405.07Zm3.49-9.41a1.45,1.45,0,0,1-.28,0,1,1,0,0,1-.68-1.24c.45-1.58.85-3.2,1.18-4.8a1,1,0,0,1,1.19-.78,1,1,0,0,1,.77,1.18c-.34,1.66-.75,3.32-1.22,4.95A1,1,0,0,1,1178,395.66Zm2-9.83h-.13a1,1,0,0,1-.86-1.12c.21-1.63.36-3.29.45-4.93a1,1,0,0,1,2,.11c-.09,1.69-.24,3.39-.46,5.08A1,1,0,0,1,1180,385.83Zm.53-10a1,1,0,0,1-1-1c0-1.64-.14-3.3-.3-4.93a1,1,0,1,1,2-.2c.16,1.68.27,3.39.3,5.09a1,1,0,0,1-1,1Zm-1-10a1,1,0,0,1-1-.83c-.29-1.61-.64-3.24-1-4.83a1,1,0,0,1,1.94-.5c.42,1.65.78,3.32,1.08,5a1,1,0,0,1-.82,1.16Zm-2.49-9.72a1,1,0,0,1-1-.68c-.52-1.56-1.12-3.11-1.76-4.62a1,1,0,1,1,1.84-.79c.66,1.56,1.27,3.16,1.82,4.76a1,1,0,0,1-.63,1.27A.87.87,0,0,1,1177.06,356.09Zm-3.94-9.24a1,1,0,0,1-.89-.54c-.7-1.36-1.47-2.72-2.27-4l-.17-.27a1,1,0,1,1,1.71-1.05l.17.28c.82,1.35,1.61,2.75,2.34,4.15a1,1,0,0,1-.43,1.35A.92.92,0,0,1,1173.12,346.85Zm-5.27-8.54a1,1,0,0,1-.81-.41c-1-1.33-2-2.64-3.06-3.89a1,1,0,0,1,1.53-1.3c1.09,1.29,2.15,2.64,3.15,4a1,1,0,0,1-.23,1.4A1,1,0,0,1,1167.85,338.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1114.31,443.64c-.82,0-1.64,0-2.46-.05a1,1,0,1,1,.08-2c.82,0,1.63,0,2.46,0h0a1,1,0,0,1,1,1A1,1,0,0,1,1114.31,443.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1106,426.6a.79.79,0,0,0,.86-.32l5.48-8a42.15,42.15,0,0,0,13.56-1.68l7.26,6.39a.8.8,0,0,0,.92.1l10.1-5.74a.78.78,0,0,0,.39-.84l-1.77-9.51a42.64,42.64,0,0,0,8.39-10.79l9.66-.62a.79.79,0,0,0,.72-.58l3.08-11.2a.8.8,0,0,0-.31-.87l-8-5.47a42.16,42.16,0,0,0-1.69-13.56l6.4-7.27a.8.8,0,0,0,.09-.92l-5.74-10.1a.79.79,0,0,0-.83-.39L1145.1,347a41.85,41.85,0,0,0-10.79-8.39l-.61-9.67a.78.78,0,0,0-.58-.71l-11.2-3.09a.8.8,0,0,0-.87.32l-5.47,8a42.25,42.25,0,0,0-13.57,1.68l-7.26-6.39a.79.79,0,0,0-.92-.1l-10.1,5.74a.8.8,0,0,0-.39.84l1.78,9.51a42.19,42.19,0,0,0-8.39,10.79l-9.67.62a.79.79,0,0,0-.72.58l-3.08,11.2a.8.8,0,0,0,.32.87l8,5.47a42.15,42.15,0,0,0,1.68,13.56l-6.4,7.27a.8.8,0,0,0-.09.92l5.74,10.1a.81.81,0,0,0,.84.39l9.51-1.78a42,42,0,0,0,10.79,8.39l.61,9.67a.79.79,0,0,0,.59.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1114,387.19a11.31,11.31,0,1,1,7.82-3.14A11.28,11.28,0,0,1,1114,387.19Zm0-20.62a9.31,9.31,0,1,0,6.44,16h0a9.31,9.31,0,0,0-6.44-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1122.4,403.39a1,1,0,0,1-1-.7,1,1,0,0,1,0-.3,1,1,0,0,1,.7-.95,27.26,27.26,0,0,0,10.83-6.47h0l0,0,.06-.05v0l.11-.11h0a27,27,0,1,0-32.46,4.43,1,1,0,0,1,.51.87,1.09,1.09,0,0,1-.13.49,1,1,0,0,1-1.37.38,29,29,0,1,1,28.64,0h0c-.41.23-.82.46-1.25.67h0l-.12.06h0a27.79,27.79,0,0,1-3.13,1.34l-.16.06-.23.08-.1,0-.63.21A1,1,0,0,1,1122.4,403.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1295.08,210.71c32.7-49.6,72-67.52,127-66.8a9.14,9.14,0,0,1,8.24,5.39l.85,1.88a9.14,9.14,0,0,1-7.57,12.87c-45.55,3.83-78.22,9.84-113.59,57.2a9.15,9.15,0,0,1-15.18-.81h0A9.14,9.14,0,0,1,1295.08,210.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1293,185.06,1285.92,234a2,2,0,0,0,2.65,2.15l44.71-16.27a2.3,2.3,0,0,0,.7-3.92c-16.4-8.45-28.74-19.3-37.73-32.13A2,2,0,0,0,1293,185.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1007.92,1045.41c-33.18,43.91-70.54,58.15-121.41,54.22a8.51,8.51,0,0,1-7.3-5.48l-.67-1.79a8.47,8.47,0,0,1,7.76-11.45c42.34-.83,72.9-4.45,108.42-46.13a8.47,8.47,0,0,1,14,1.64h0A8.49,8.49,0,0,1,1007.92,1045.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1008.32,1069.25l9.45-44.83a1.85,1.85,0,0,0-2.33-2.15l-42.3,12.39a2.14,2.14,0,0,0-.88,3.59c14.66,8.78,25.42,19.54,33,31.94A1.84,1.84,0,0,0,1008.32,1069.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1254,1043.93c3.76,54.91,27.24,87.27,72,111.79a8.48,8.48,0,0,0,9.11-.59l1.54-1.13a8.48,8.48,0,0,0-.24-13.84c-35-23.85-58.6-43.59-65.54-97.91a8.47,8.47,0,0,0-12.61-6.27h0A8.49,8.49,0,0,0,1254,1043.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1240.67,1063.67l16.6-42.7a1.84,1.84,0,0,1,3.12-.53L1289,1054a2.14,2.14,0,0,1-1.22,3.49c-17.08-.67-32,2.45-45.08,8.7A1.83,1.83,0,0,1,1240.67,1063.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1372.39,960.44c-1.81,64.52-7.67,287.08-4.87,366,.29,8.36,7.86,15.06,17.3,15.34,46.67,1.35,217.79,4.78,294.13,1.94,15.9-.59,28.55-12,28.88-26.08,1.59-67.73,5.09-258.21-3.23-345.47-1-10.45-10.27-18.78-22.06-19.82-50.83-4.5-222.68-15.51-288.64-11.72C1382,941.26,1372.68,949.89,1372.39,960.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1393.21,975.47c-2.51,15.08-10.44,65.25-7.92,83.81.37,2.71,8.7,4.9,19.27,5.06,43.5.65,191.91,2.09,255.72.78,11.48-.24,20.5-2.62,21.12-5.57,3.23-15.38,12.52-62.1,10.11-80.44-.39-2.93-9.23-5.32-20.61-5.58-47.06-1.08-204.76-3.66-259-2.9C1401.74,970.77,1393.65,972.86,1393.21,975.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1671.69,988.58a12.56,12.56,0,0,0-8.8-3.82l-244.45-3.88a12.51,12.51,0,0,0-12.66,11.35l-5.08,54.23c-.42,4.44,6.89,8.18,16.2,8.29l240.33,2.91c9.3.12,17-3.43,17.07-7.87l.9-52.3A12.47,12.47,0,0,0,1671.69,988.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1395.14,
    y: 1100.65,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1475.59,
    y: 1100.65,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1550.36,
    y: 1100.65,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1683,1120.56a17.75,17.75,0,0,1-17.75,17.75h-20.55a17.75,17.75,0,0,1-17.75-17.75h0a17.75,17.75,0,0,1,17.75-17.75h20.55a17.75,17.75,0,0,1,17.75,17.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1395.14,
    y: 1154.59,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1475.59,
    y: 1154.59,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1550.36,
    y: 1154.59,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1630.8,
    y: 1154.59,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1395.14,
    y: 1206.65,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1475.59,
    y: 1206.65,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1550.36,
    y: 1206.65,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1395.14,
    y: 1259.65,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1475.59,
    y: 1259.65,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1550.36,
    y: 1259.65,
    width: 56.79,
    height: 35.02,
    rx: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1633.64,
    y: 1208.54,
    width: 44.48,
    height: 86.13,
    rx: 22.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-78",
    cx: 1647.94,
    cy: 821.11,
    r: 53.68,
    transform: "translate(160.69 1906.48) rotate(-62.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1603.67,799.81a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34,50.65,50.65,0,0,1,54.28-27,1,1,0,0,1,.8,1.16,1,1,0,0,1-1.16.81,48.64,48.64,0,0,0-52.14,25.91A1,1,0,0,1,1603.67,799.81Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-79",
    cx: 1649.11,
    cy: 822.28,
    r: 45.43,
    transform: "translate(523.83 2281.54) rotate(-78.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1644.65,856.06v-4.95a40.24,40.24,0,0,1-13.87-3,2.86,2.86,0,0,1-1.58-3.38l1.25-4.61a2.89,2.89,0,0,1,3.92-1.88,33.54,33.54,0,0,0,12.8,2.7c5,0,8.67-1.69,8.67-5.14,0-3.11-2.86-5-9.76-6.81-9.84-2.69-16.91-7-16.91-15.65,0-7.82,5.72-13.79,15.65-15.39V793a2.87,2.87,0,0,1,2.88-2.88h2.9a2.87,2.87,0,0,1,2.88,2.88v4.43a36.57,36.57,0,0,1,11,2,2.84,2.84,0,0,1,1.79,3.46l-1.15,4.26a2.88,2.88,0,0,1-3.79,1.94,30,30,0,0,0-10.78-2c-5.89,0-7.57,2.44-7.57,4.62,0,2.7,3.53,4.55,11.18,6.9,10.94,3.28,15.48,7.83,15.48,16,0,7.48-5.55,14.21-16.32,15.9v5.53a2.88,2.88,0,0,1-2.88,2.88h-2.9A2.88,2.88,0,0,1,1644.65,856.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-81",
    cx: 1718.31,
    cy: 916.05,
    r: 39.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1685.88,900.71a1,1,0,0,1-.45-.1,1,1,0,0,1-.44-1.35,37.17,37.17,0,0,1,33.32-20.52,37.77,37.77,0,0,1,6.73.61,1,1,0,1,1-.35,2,35.79,35.79,0,0,0-6.38-.58,35.19,35.19,0,0,0-31.54,19.42A1,1,0,0,1,1685.88,900.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-79",
    cx: 1719.17,
    cy: 916.91,
    r: 33.29,
    transform: "translate(540.02 2468) rotate(-80.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1715.9,941.66V938a29.76,29.76,0,0,1-10.16-2.21,2.09,2.09,0,0,1-1.16-2.47l.92-3.38a2.12,2.12,0,0,1,2.87-1.38,24.38,24.38,0,0,0,9.38,2c3.64,0,6.35-1.24,6.35-3.76,0-2.28-2.09-3.64-7.15-5-7.21-2-12.39-5.12-12.39-11.47,0-5.73,4.19-10.11,11.47-11.28v-3.62a2.1,2.1,0,0,1,2.11-2.11h2.13a2.11,2.11,0,0,1,2.11,2.11v3.25a26.89,26.89,0,0,1,8,1.45,2.1,2.1,0,0,1,1.31,2.53l-.84,3.12a2.1,2.1,0,0,1-2.78,1.42,22.07,22.07,0,0,0-7.9-1.43c-4.32,0-5.55,1.79-5.55,3.39,0,2,2.59,3.33,8.2,5,8,2.41,11.34,5.74,11.34,11.71,0,5.49-4.07,10.42-12,11.65v4.06a2.11,2.11,0,0,1-2.11,2.11H1718A2.12,2.12,0,0,1,1715.9,941.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1600.81,
    cy: 930.44,
    r: 50.82,
    transform: "translate(-189.06 1404.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1558.9,910.33a1,1,0,0,1-.45-.1,1,1,0,0,1-.44-1.35,48,48,0,0,1,51.45-25.57,1,1,0,0,1,.8,1.16,1,1,0,0,1-1.16.81,46,46,0,0,0-49.3,24.5A1,1,0,0,1,1558.9,910.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-79",
    cx: 1601.92,
    cy: 931.55,
    r: 43.01,
    transform: "translate(-232.43 668.67) rotate(-22.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1597.7,963.53v-4.68a38.22,38.22,0,0,1-13.13-2.85,2.7,2.7,0,0,1-1.5-3.2l1.19-4.35a2.73,2.73,0,0,1,3.7-1.79,31.61,31.61,0,0,0,12.13,2.55c4.7,0,8.2-1.59,8.2-4.86,0-2.94-2.71-4.69-9.24-6.45-9.32-2.54-16-6.61-16-14.81,0-7.41,5.42-13.06,14.82-14.57v-4.68a2.72,2.72,0,0,1,2.72-2.73h2.75a2.73,2.73,0,0,1,2.73,2.73V908a34.65,34.65,0,0,1,10.41,1.87,2.7,2.7,0,0,1,1.69,3.27l-1.09,4a2.72,2.72,0,0,1-3.59,1.84,28.33,28.33,0,0,0-10.21-1.85c-5.57,0-7.16,2.31-7.16,4.38,0,2.55,3.34,4.3,10.59,6.53,10.35,3.1,14.65,7.4,14.65,15.13,0,7.09-5.25,13.46-15.45,15v5.24a2.72,2.72,0,0,1-2.72,2.73h-2.75A2.73,2.73,0,0,1,1597.7,963.53Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg1);
export default __webpack_public_path__ + "static/media/about_img_1.258fdaf738b9aaf592e29b6e629a32e0.svg";
export { ForwardRef as ReactComponent };